import jsPDF from 'jspdf';



import autoTable from 'jspdf-autotable';



import { COMPANY as C } from '../config/company';



import {



  san, sanPdf, fmtDate, formatAddr, numberToWords, currencyUnitName, formatAmountInWords,



  getTaxInfo, getItemTaxRate, computeTotals,

} from './pdfUtils';

import { getCoaImageUrl } from './assetPaths';







// ─── Colour palette ───────────────────────────────────────────────────────────



const NAVY = [15, 40, 80];   // deep navy — header background



const RED = [196, 30, 58];   // PRASI brand red



const GOLD = [200, 155, 40];   // accent gold



const DARK = [20, 20, 20];   // near-black body text



const GRAY = [100, 100, 100];  // secondary text



const LGRAY = [220, 220, 220];  // borders



const BGRAY = [247, 248, 250];  // alternating row fill



const WHITE = [255, 255, 255];







// ─── A4 page constants (mm) ───────────────────────────────────────────────────



const LM = 10, RM = 200, CW = 190;







// ─── Utilities ────────────────────────────────────────────────────────────────



// Note: fmtDate, numberToWords, currencyUnitName, formatAmountInWords,



// getTaxInfo, getItemTaxRate, and computeTotals are imported from ./pdfUtils.















async function loadLogoBase64() {



  try {



    const res = await fetch('/prasilabs-logo.png');



    const blob = await res.blob();



    return await new Promise(resolve => {



      const r = new FileReader();



      r.onloadend = () => resolve(r.result);



      r.readAsDataURL(blob);



    });



  } catch { return null; }



}







async function loadCompanySettings() {



  try {



    const token = localStorage.getItem('token');



    const base = process.env.REACT_APP_API_URL || '/api';



    const r = await fetch(`${base}/company-settings`, {



      headers: token ? { Authorization: `Bearer ${token}` } : {},



    });



    if (!r.ok) return {};



    const json = await r.json();



    return json.data || {};



  } catch { return {}; }



}







async function generateQR(text, opts = {}) {



  try {



    // Dynamic import avoids static bundling of Node.js-specific qrcode internals



    const { default: QRCode } = await import('qrcode');



    // Replace em-dashes with hyphens so the string stays in ASCII range



    const safe = String(text).replace(/—/g, '-');



    return await QRCode.toDataURL(safe, {



      width: 400, margin: 1,



      errorCorrectionLevel: 'M',   // 'M' is better balance for scanning



      color: { dark: '#000000', light: '#FFFFFF' },



      ...opts,



    });



  } catch { return null; }



}







// ─── Page border (redrawn on every page when content overflows) ───────────────



function drawPageBorder(doc) {



  const H = doc.internal.pageSize.getHeight();



  doc.setDrawColor(...LGRAY);



  doc.setLineWidth(0.4);



  doc.roundedRect(LM, 10, CW, H - 20, 3, 3);



}







// ─── Page footer (page X of Y + generated date) applied to all pages ─────────



function finalizePageFooters(doc, settings = {}) {



  const total = doc.internal.getNumberOfPages();



  const W = doc.internal.pageSize.getWidth();



  const H = doc.internal.pageSize.getHeight();



  const today = new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });



  for (let i = 1; i <= total; i++) {



    doc.setPage(i);



    doc.setFont('helvetica', 'normal');



    doc.setFontSize(6.5);



    doc.setTextColor(...GRAY);



    doc.text(settings.name || C.name, LM + 3, H - 5);



    doc.text(`Page ${i} of ${total}`, W / 2, H - 5, { align: 'center' });



    doc.text(`Generated: ${today}`, RM, H - 5, { align: 'right' });



  }



}







// ─── DRAFT watermark ──────────────────────────────────────────────────────────



function drawDraftWatermark(doc) {



  const W = doc.internal.pageSize.getWidth();



  const H = doc.internal.pageSize.getHeight();



  doc.saveGraphicsState();



  doc.setGState(new doc.GState({ opacity: 0.07 }));



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(72);



  doc.setTextColor(...RED);



  doc.text('PRASI LABS', W / 2, H / 2, { align: 'center', angle: 45 });



  doc.restoreGraphicsState();



}







// ─────────────────────────────────────────────────────────────────────────────



//  SHARED DRAWING BLOCKS



// ─────────────────────────────────────────────────────────────────────────────







/**



 * Professional header: light background with logo, company info, navy/gold accents.



 * Layout: y=10..44 (34 mm). Returns 44.



 */



function drawCompanyHeader(doc, titleText, logoDataUrl, settings = {}) {



  const W = doc.internal.pageSize.getWidth();



  const H = doc.internal.pageSize.getHeight();







  // Outer border (full printable area)



  doc.setDrawColor(...LGRAY);



  doc.setLineWidth(0.4);



  doc.roundedRect(LM, 10, CW, H - 20, 3, 3);







  // ── Top navy accent bar ───────────────────────────────────────────────────



  doc.setFillColor(...NAVY);



  doc.rect(LM, 10, CW, 1.5, 'F');







  // ── Gold accent bar at header bottom ─────────────────────────────────────



  doc.setFillColor(...GOLD);



  doc.rect(LM, 44, CW, 0.8, 'F');







  // ── Logo (top-left of header) ─────────────────────────────────────────────



  let logoRight = LM + 3;



  if (logoDataUrl) {



    try {



      doc.addImage(logoDataUrl, 'PNG', LM + 3, 13.5, 32, 18);



      logoRight = LM + 37;



    } catch { /* skip */ }



  }







  // ── Company text (right of logo) ──────────────────────────────────────────



  const hx = logoRight + 2;



  const textMaxW = RM - hx - 45;   // leave room for title badge







  doc.setFont('helvetica', 'bold');



  doc.setFontSize(11.5);



  doc.setTextColor(...NAVY);



  doc.text(settings.name || C.name, hx, 20);







  doc.setFont('helvetica', 'normal');



  doc.setFontSize(6.2);



  doc.setTextColor(50, 60, 75);







  const addrFull = settings.address || C.address.full;



  const addrLines = doc.splitTextToSize(addrFull, textMaxW);



  doc.text(addrLines.slice(0, 2), hx, 25);







  const contactY = addrLines.length > 1 ? 32 : 28.5;



  doc.text(`Ph: ${settings.phone || C.phone}   |   ${settings.email || C.email}   |   ${settings.website || C.website}`, hx, contactY);







  doc.setFontSize(5.8);



  doc.setTextColor(40, 50, 70);



  doc.text(



    `GST: ${settings.gstin || C.gstin}   |   MSME: ${settings.msme || C.msme}   |   LUT: ${settings.lut || C.lut} (${settings.lutDate || C.lutDate})`,



    hx, contactY + 3.5



  );







  // ── Document type badge (top-right of header) ─────────────────────────────



  const badgeW = 35, badgeH = 14;



  const badgeX = RM - badgeW - 2;



  const badgeY = 16;



  doc.setFillColor(...NAVY);



  doc.roundedRect(badgeX, badgeY, badgeW, badgeH, 2, 2, 'F');



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(7.5);



  doc.setTextColor(...WHITE);



  doc.text(titleText, badgeX + badgeW / 2, badgeY + badgeH / 2 + 0.5, { align: 'center', baseline: 'middle' });







  return 44;



}







/**



 * Billing / shipping two-column section.



 * Layout: y=44..71 (27 mm). Returns 71.



 */



function drawBillingSection(doc, order) {



  const midX = LM + CW / 2;



  const colW = CW / 2 - 6;



  const bx = LM + 3;



  const sx = midX + 3;







  // Section header background (thin strip)



  doc.setFillColor(...BGRAY);



  doc.rect(LM, 44, CW, 7, 'F');







  // Vertical column divider



  doc.setDrawColor(...LGRAY);



  doc.setLineWidth(0.2);



  doc.line(midX, 44, midX, 71);







  // Column headers



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(6.5);



  doc.setTextColor(...NAVY);



  doc.text('BILL TO', bx, 49);



  doc.text('SHIP TO', sx, 49);







  // Data



  const clientName = order.client_name || '';



  const clientEmail = order.client_email || '';



  const clientPhone = order.client_phone || order.client_phone_derived || '';



  const billAddr = order.client_address || order.client_address_derived || order.client_country || '';



  const shipAddr = order.shipping_address || billAddr;







  // Billing column



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(8.5);



  doc.setTextColor(...DARK);



  if (clientName) doc.text(doc.splitTextToSize(clientName, colW)[0], bx, 54.5);







  doc.setFont('helvetica', 'normal');



  doc.setFontSize(7);



  doc.setTextColor(...DARK);



  if (clientEmail) doc.text(clientEmail, bx, 59);







  const bAddr = formatAddr(



    order.client_address || order.client_address_derived || order.client_country || '',



    order.client_city, order.client_state, order.client_zip, order.client_country



  );



  const billAddrL = doc.splitTextToSize(bAddr, colW);



  if (billAddrL[0]) doc.text(billAddrL[0], bx, 63);



  if (clientPhone) doc.text(`Ph: ${clientPhone}`, bx, 67);







  // Shipping column



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(8.5);



  doc.setTextColor(...DARK);



  if (clientName) doc.text(doc.splitTextToSize(clientName, colW)[0], sx, 54.5);







  doc.setFont('helvetica', 'normal');



  doc.setFontSize(7);



  doc.setTextColor(...DARK);



  const sAddr = formatAddr(shipAddr, order.client_city, order.client_state, order.client_zip, order.client_country);



  const shipAddrL = doc.splitTextToSize(sAddr, colW);



  if (shipAddrL[0]) doc.text(shipAddrL[0], sx, 59);



  if (clientPhone) doc.text(`Ph: ${clientPhone}`, sx, 63);







  // GSTIN / State Code



  const gstParts = [



    order.client_gstin ? `GSTIN: ${order.client_gstin}` : null,



    order.client_state_code ? `State Code: ${order.client_state_code}` : null,



  ].filter(Boolean);



  if (gstParts.length) {



    doc.setFont('helvetica', 'bold');



    doc.setFontSize(6.8);



    doc.setTextColor(...GRAY);



    doc.text(gstParts.join('   |   '), bx, 70);



  }







  doc.setDrawColor(...LGRAY);



  doc.setLineWidth(0.2);



  doc.line(LM, 71, RM, 71);



  return 71;



}







/**



 * Striped info grid rows. Each row: 7.5 mm. Returns y after last row.



 */



function drawInfoGrid(doc, startY, rows) {



  const ROW_H = 7.5;



  const HALF = CW / 2;



  let gy = startY;



  rows.forEach(([left, right], idx) => {



    if (idx % 2 === 0) {



      doc.setFillColor(...BGRAY);



      doc.rect(LM, gy, CW, ROW_H, 'F');



    }



    doc.setDrawColor(...LGRAY);



    doc.setLineWidth(0.2);



    doc.rect(LM, gy, CW, ROW_H);



    doc.line(LM + HALF, gy, LM + HALF, gy + ROW_H);







    doc.setFont('helvetica', 'bold');



    doc.setFontSize(7.5);



    doc.setTextColor(...DARK);



    doc.text(left, LM + 3, gy + 4.8);



    doc.text(right, LM + HALF + 3, gy + 4.8);



    gy += ROW_H;



  });



  return gy;



}







/**



 * Items table + 2-column summary footer + amount-in-words bar.



 * Invoice column widths (sum = 190 mm):



 *   SL#(8) + Item(72) + HSN(16) + Qty(16) + Amount(28) + Tax(50) = 190



 * Returns y after the amount bar.



 */



function drawItemsAndSummary(doc, order, startY, tots) {



  const W = doc.internal.pageSize.getWidth();



  const { tax } = tots;



  const cur = order.currency || 'USD';



  const items = order.items || [];







  const tableRows = items.map((it, i) => {



    const rowAmt = Number(it.total || 0);



    const itemRate = getItemTaxRate(it, tax);



    const hsnSac = it.hsn_code || it.sac_code || '—';



    const metaParts = [];



    if (it.cas_number) metaParts.push(`CAS: ${it.cas_number}`);



    


    if (it.sac_code && !it.hsn_code) metaParts.push(`SAC: ${it.sac_code}`);



    const desc = [



      it.item_name || '—',



      metaParts.length ? metaParts.join(' | ') : '',



      it.pack_size ? `Pack: ${it.pack_size}` : '',



    ].filter(Boolean).join('\n');



    let taxCell;



    if (tax.isExport) {



      taxCell = 'LUT/Zero Rated\nIGST@0%';



    } else if (tax.isIGST) {



      taxCell = `IGST@${itemRate}%\n${(rowAmt * itemRate / 100).toFixed(2)}`;



    } else {



      const half = itemRate / 2;



      taxCell = `CGST@${half}%: ${(rowAmt * half / 100).toFixed(2)}\nSGST@${half}%: ${(rowAmt * half / 100).toFixed(2)}`;



    }



    return [i + 1, desc, hsnSac, `${it.quantity || 1} Nos`, rowAmt.toFixed(2), taxCell];



  });







  // Pre-compute right-column height so margin.bottom and footer box are sized correctly.



  // The totals column grows with extra charges; we derive the exact height before drawing.



  const MIN_FOOTER_H = 50; // 6 dispatch fields × 5mm + 6mm top offset = 36mm; 50 gives extra breathing room



  let _sy = 5;



  const _inc = (bold = false) => { _sy += bold ? 6 : 4.5; };



  _inc(); // Net Amount



  if (tots.freightAmt > 0) { _inc(); if (tots.freightGst > 0) _inc(); } // Freight + GST sub-line



  _inc(); _inc(); // Net Tax, Gross Amount



  tots.charges.filter(c => Number(c.amount) > 0).forEach(c => {



    _inc();



    if (Number(c.gst_pct) > 0) _inc();



  });



  _inc();      // Rounding Off



  _inc(true);  // Total Payable (bold)



  _sy += 2;    // extra spacing so Total Payable appears below separator line



  const FOOTER_H = Math.max(MIN_FOOTER_H, _sy + 5);



  const WORDS_H = 10; // taller, more readable amount-in-words bar







  autoTable(doc, {



    startY,



    head: [['SL#', 'Item Description', 'HSN', 'Qty', 'Amount', 'Tax Breakup']],



    body: tableRows,



    margin: { left: LM, right: LM, top: 12, bottom: FOOTER_H + WORDS_H + 62 },



    styles: { fontSize: 7.5, cellPadding: [2, 2, 2, 2], lineColor: LGRAY, lineWidth: 0.2, textColor: DARK, valign: 'top' },



    headStyles: { fillColor: NAVY, textColor: WHITE, fontStyle: 'bold', fontSize: 7.5, halign: 'center' },



    alternateRowStyles: { fillColor: BGRAY },



    columnStyles: {



      0: { cellWidth: 8, halign: 'center' },



      1: { cellWidth: 72 },



      2: { cellWidth: 16, halign: 'center' },



      3: { cellWidth: 16, halign: 'center' },



      4: { cellWidth: 28, halign: 'right' },



      5: { cellWidth: 50, halign: 'right' },



    },



    theme: 'grid',



    didAddPage: (data) => drawPageBorder(data.doc),



  });







  // finalY is always guaranteed to have ≥114 mm below it (enforced by margin.bottom above).



  let y = doc.lastAutoTable.finalY;







  // ── 2-column summary footer (height = FOOTER_H, pre-computed above) ─────────



  const splitX = LM + CW / 2;







  doc.setDrawColor(...LGRAY);



  doc.setLineWidth(0.2);



  doc.line(LM, y, RM, y);



  doc.line(splitX, y, splitX, y + FOOTER_H);



  doc.line(LM, y + FOOTER_H, RM, y + FOOTER_H);







  // Left: freight / additional info



  const lx = LM + 3;



  const FVAL_X = lx + 32;



  const FVAL_W = splitX - FVAL_X - 3;



  let fy = y + 6;



  const drawL = (lbl, val) => {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(...GRAY);



    doc.text(lbl, lx, fy);



    doc.setFont('helvetica', 'normal'); doc.setTextColor(...(val && val !== '—' ? DARK : GRAY));



    const tv = doc.splitTextToSize(val && val !== '' ? String(val) : '—', FVAL_W)[0];



    doc.text(tv, FVAL_X, fy);



    fy += 5;



  };



  drawL('Transport:', order.transport || '');



  drawL('Dispatch Doc:', order.dispatch_doc_number || '');



  drawL('Dated:', order.dispatch_doc_date ? fmtDate(order.dispatch_doc_date) : '');



  drawL('Destination:', order.destination || '');



  drawL('Terms of Del.:', order.terms_of_delivery || '');



  drawL('Freight Detail:', order.freight_detail || '');



  if (order.additional_info) {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(...GRAY);



    doc.text('Additional Info:', lx, fy); fy += 4;



    doc.setFont('helvetica', 'normal'); doc.setFontSize(6.8); doc.setTextColor(...DARK);



    doc.text(doc.splitTextToSize(order.additional_info, splitX - lx - 4).slice(0, 4), lx, fy);



  }







  // Right: totals



  const rx = splitX + 3;



  const vx = RM - 3;



  let sy = y + 5;



  const drawR = (lbl, val, bold = false) => {



    doc.setFont('helvetica', bold ? 'bold' : 'normal');



    doc.setFontSize(bold ? 8.5 : 7.5);



    doc.setTextColor(...(bold ? NAVY : GRAY));



    doc.text(lbl, rx, sy);



    doc.setTextColor(...(bold ? NAVY : DARK));



    doc.text(val, vx, sy, { align: 'right' });



    sy += bold ? 6 : 4.5;



  };



  drawR('Net Amount', `${cur} ${tots.netAmt.toFixed(2)}`);



  if (tots.freightAmt > 0) {



    drawR('Freight', `${cur} ${tots.freightAmt.toFixed(2)}`);



    if (tots.freightGst > 0) {



      drawR(`  Freight GST (${Number(order.freight_gst_pct || 0).toFixed(1)}%)`, `${cur} ${tots.freightGst.toFixed(2)}`);



    }



  }



  drawR('Net Tax', `${cur} ${tots.netTax.toFixed(2)}`);



  drawR('Gross Amount', `${cur} ${tots.gross.toFixed(2)}`);



  tots.charges.filter(c => Number(c.amount) > 0).forEach(c => {



    drawR(c.label || 'Other Charge', `${cur} ${Number(c.amount).toFixed(2)}`);



    if (Number(c.gst_pct) > 0) {



      drawR(`  GST @${c.gst_pct}%`, `${cur} ${(Number(c.amount) * Number(c.gst_pct) / 100).toFixed(2)}`);



    }



  });



  drawR('Rounding Off', `${cur} ${tots.rounding >= 0 ? '+' : ''}${tots.rounding.toFixed(2)}`);







  // ── Total Payable row ─────────────────────────────────────────────────────



  doc.setDrawColor(...LGRAY); doc.setLineWidth(0.3);



  doc.line(splitX, sy + 2, RM, sy + 2);



  sy += 6;



  drawR('Total Payable', `${cur} ${tots.payable.toFixed(2)}`, true);







  y += FOOTER_H;







  // ── Amount-in-words bar (anchored directly below the summary footer) ──────



  const wordsText = `Amount (${cur}): ${numberToWords(tots.payable)} ONLY`;



  doc.setFillColor(...NAVY);



  doc.roundedRect(LM, y, CW, WORDS_H, 2, 2, 'F');



  // Gold accent bars on both sides



  doc.setFillColor(...GOLD);



  doc.rect(LM, y, 3, WORDS_H, 'F');



  doc.rect(RM - 3, y, 3, WORDS_H, 'F');



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(7.5);



  doc.setTextColor(...WHITE);



  const wLines = doc.splitTextToSize(wordsText, CW - 16);



  doc.text(wLines, W / 2, y + WORDS_H / 2 + (wLines.length > 1 ? -1.5 : 1.5), { align: 'center' });



  return y + WORDS_H;



}







/**



 * Bottom section: 3-column — Terms | QR Codes | Bank + Signature.



 * Column widths: 65 + 50 + 75 = 190 mm. Section height = 55 mm.



 */



async function drawBottomSection(doc, order, y, isProforma, settings = {}, qr1DataUrl = null, qr2DataUrl = null) {



  const W = doc.internal.pageSize.getWidth();



  const H = doc.internal.pageSize.getHeight();



  const BOTTOM_H = 70;  // increased from 62 to give more vertical room for larger QRs







  const col1X = LM;        // Terms col start



  const col1W = 65;



  const col2X = LM + 65;   // QR col start



  const col2W = 50;



  const col3X = LM + 115;  // Bank+sig col start



  const col3W = 75;



  const docType = isProforma ? 'PROFORMA INVOICE' : 'TAX INVOICE';







  // Section borders



  doc.setDrawColor(...LGRAY);



  doc.setLineWidth(0.2);



  doc.line(col2X, y, col2X, y + BOTTOM_H);



  doc.line(col3X, y, col3X, y + BOTTOM_H);



  doc.line(LM, y + BOTTOM_H, RM, y + BOTTOM_H);







  // ── COL 1: Insurance, note, terms ─────────────────────────────────────────



  const lx = col1X + 3;



  const lMaxW = col1W - 5;



  let py = y + 5;







  doc.setFont('helvetica', 'normal');



  doc.setFontSize(6.5);



  doc.setTextColor(...GRAY);







  const ins = settings.insurancePolicy



    ? `Policy: ${settings.insurancePolicy} — ${settings.insuranceType || ''} (${settings.insuranceCompany || ''})`



    : `Policy: ${C.insurance.policy} — ${C.insurance.type} (${C.insurance.company})`;



  const il = doc.splitTextToSize(ins, lMaxW);



  doc.text(il, lx, py);



  py += il.length * 3.5 + 3;







  doc.setFont('helvetica', 'bold');



  doc.text('Note:', lx, py);



  doc.setFont('helvetica', 'normal');



  doc.text(` Computer generated ${docType}.`, lx + 9, py);



  py += 4;







  // Export/LUT legal declaration (mandatory for exports under GST)



  const tax = computeTotals(order).tax;



  if (tax.isExport && !isProforma) {



    const lutDecl = order.lut_bond === 'with_payment'



      ? 'Supply of goods meant for EXPORT WITH PAYMENT OF IGST under Bond/LUT Ref: ' + (order.lut_ref || (settings.lut || C.lut))



      : 'Supply of goods/services meant for EXPORT UNDER LUT/BOND without payment of Integrated Tax. LUT Ref: ' + (settings.lut || C.lut) + ' dt. ' + (settings.lutDate || C.lutDate);



    doc.setFontSize(6);



    doc.setFont('helvetica', 'bold');



    doc.setTextColor(22, 101, 52); // green



    const lutLines = doc.splitTextToSize(lutDecl, lMaxW);



    doc.text(lutLines, lx, py);



    py += lutLines.length * 3.2 + 3;



    doc.setTextColor(...GRAY);



  }







  // Credit note reference



  if (order.order_type === 'credit_note' && (order.original_invoice_id || order.credit_note_reason)) {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(6.2); doc.setTextColor(153, 27, 27);



    doc.text('CREDIT NOTE', lx, py); py += 3.5;



    doc.setFont('helvetica', 'normal'); doc.setFontSize(6); doc.setTextColor(153, 27, 27);



    if (order.credit_note_reason) {



      const rl = doc.splitTextToSize(`Reason: ${order.credit_note_reason}`, lMaxW);



      doc.text(rl, lx, py); py += rl.length * 3 + 1;



    }



    doc.setTextColor(...GRAY);



    doc.text('(Issued under Section 34 CGST Act)', lx, py); py += 4;



  }







  const terms = isProforma



    ? [



      'This document shows the estimated price of goods.',



      'Payment should include any additional charges.',



      'Subject to Hyderabad (India) jurisdiction.',



    ]



    : order.order_type === 'credit_note'



      ? [



        'This is a credit note against a valid tax invoice.',



        'Differential GST as per Section 34 CGST Act.',



        'E&OE. Subject to Hyderabad (India) jurisdiction.',



      ]



      : [



        'This document shows the actual price of goods.',



        'Final payment to include any additional charges.',



        'E&OE. Subject to Hyderabad (India) jurisdiction.',



      ];







  doc.setFontSize(6.5);



  doc.setTextColor(...GRAY);



  terms.forEach(t => {



    const tl = doc.splitTextToSize(t, lMaxW);



    doc.text(tl, lx, py);



    py += tl.length * 3.5 + 1;



  });







  // ── COL 2: QR Codes ───────────────────────────────────────────────────────



  const qx = col2X + 3;



  const qrSize = 22;   // mm per QR code (increased from 20 for better scanning)



  const qColW = col2W - 6;



  let qy = y + 4;







  // QR 1 — Invoice Summary



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(6);



  doc.setTextColor(...NAVY);



  doc.text('DOCUMENT INFO', col2X + col2W / 2, qy, { align: 'center' });



  qy += 3.5;







  if (qr1DataUrl) {



    doc.addImage(qr1DataUrl, 'PNG', col2X + (col2W - qrSize) / 2, qy, qrSize, qrSize);



  } else {



    doc.setDrawColor(...LGRAY);



    doc.rect(col2X + (col2W - qrSize) / 2, qy, qrSize, qrSize);



    doc.setFont('helvetica', 'normal');



    doc.setFontSize(5.5);



    doc.setTextColor(...GRAY);



    doc.text('QR', col2X + col2W / 2, qy + qrSize / 2, { align: 'center' });



  }



  qy += qrSize + 2;



  doc.setFont('helvetica', 'normal');



  doc.setFontSize(5.5);



  doc.setTextColor(...GRAY);



  doc.text('Scan for order details', col2X + col2W / 2, qy, { align: 'center' });



  qy += 4;







  // QR 2 — Payment Link (only if enabled in company settings)



  if (settings.showPaymentOnInvoice !== false) {



    doc.setFont('helvetica', 'bold');



    doc.setFontSize(6);



    doc.setTextColor(...NAVY);



    doc.text('PAY NOW', col2X + col2W / 2, qy, { align: 'center' });



    qy += 3.5;







    if (qr2DataUrl) {



      doc.addImage(qr2DataUrl, 'PNG', col2X + (col2W - qrSize) / 2, qy, qrSize, qrSize);



    } else {



      doc.setDrawColor(...LGRAY);



      doc.rect(col2X + (col2W - qrSize) / 2, qy, qrSize, qrSize);



      doc.setFont('helvetica', 'normal');



      doc.setFontSize(5.5);



      doc.setTextColor(...GRAY);



      doc.text('QR', col2X + col2W / 2, qy + qrSize / 2, { align: 'center' });



    }



    qy += qrSize + 2;



    // Label configured in Company Settings



    const payQrLabel = settings.paymentQrLabel || 'Scan to pay online';



    const payLabelLines = doc.splitTextToSize(payQrLabel, qColW);



    doc.setFont('helvetica', 'normal');



    doc.setFontSize(5.5);



    doc.setTextColor(...GRAY);



    doc.text(payLabelLines, col2X + col2W / 2, qy, { align: 'center' });



    qy += payLabelLines.length * 3 + 1;



    // Show the payment URL prefix for manual entry



    const payUrl = settings.paymentLink || C.paymentLink || '';



    if (payUrl) {



      const shortUrl = payUrl.length > 32 ? payUrl.slice(0, 30) + '…' : payUrl;



      doc.setFontSize(4.8);



      doc.setTextColor(140, 140, 140);



      doc.text(shortUrl, col2X + col2W / 2, qy, { align: 'center' });



    }



  }







  // ── COL 3: Bank details + signature ───────────────────────────────────────



  const bx = col3X + 3;



  const vx = RM - 3;



  let by = y + 5;







  doc.setFont('helvetica', 'bold');



  doc.setFontSize(7);



  doc.setTextColor(...NAVY);



  doc.text('Bank Details:', bx, by);



  by += 5;







  const bankName = settings.bankName || C.bank.name;



  const bankAccount = settings.bankAccount || C.bank.account;



  const bankIfsc = settings.bankIfsc || C.bank.ifsc;



  const bankBranch = settings.bankBranch || C.bank.branch;







  [



    ['Bank:', bankName],



    ['A/C:', bankAccount],



    ['IFSC:', bankIfsc],



    ['Branch:', bankBranch],



  ].forEach(([lbl, val]) => {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(6.5); doc.setTextColor(...GRAY);



    doc.text(lbl, bx, by);



    doc.setFont('helvetica', 'normal'); doc.setTextColor(...DARK);



    doc.text(val, bx + 12, by);



    by += 4;



  });







  by += 2;



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(7);



  doc.setTextColor(...DARK);



  doc.text(`For ${settings.name || C.name}`, vx, by, { align: 'right' });



  by += 2;







  // Dashed signature box



  const boxW = col3W - 10;



  doc.setDrawColor(...GRAY);



  doc.setLineDashPattern([2, 1], 0);



  doc.roundedRect(col3X + 5, by, boxW, 13, 2, 2);



  doc.setLineDashPattern([], 0);



  by += 15;



  doc.setFont('helvetica', 'normal');



  doc.setFontSize(6.5);



  doc.setTextColor(...GRAY);



  doc.text('Authorized Signatory', col3X + 5 + boxW / 2, by, { align: 'center' });







}







// ─────────────────────────────────────────────────────────────────────────────



//  COMPACT HEADER  (Invoice + Proforma — saves ~12 mm vs full header)



// ─────────────────────────────────────────────────────────────────────────────



function drawCompactHeader(doc, titleText, logoDataUrl, settings = {}) {



  const W = doc.internal.pageSize.getWidth();



  const H = doc.internal.pageSize.getHeight();







  // Outer border



  doc.setDrawColor(...LGRAY);



  doc.setLineWidth(0.4);



  doc.roundedRect(LM, 10, CW, H - 20, 3, 3);







  // Top navy bar



  doc.setFillColor(...NAVY);



  doc.rect(LM, 10, CW, 1.5, 'F');







  // Logo



  let logoRight = LM + 3;



  if (logoDataUrl) {



    try { doc.addImage(logoDataUrl, 'PNG', LM + 3, 12.5, 28, 16); logoRight = LM + 34; }



    catch { /* skip */ }



  }







  // Company text



  const hx = logoRight + 2;



  const textMaxW = RM - hx - 44;



  doc.setFont('helvetica', 'bold'); doc.setFontSize(10.5); doc.setTextColor(...NAVY);



  doc.text(settings.name || C.name, hx, 18.5);







  doc.setFont('helvetica', 'normal'); doc.setFontSize(6.2); doc.setTextColor(50, 60, 75);



  const addrFull = settings.address || C.address.full;



  const addrLines = doc.splitTextToSize(addrFull, textMaxW);



  doc.text(addrLines.slice(0, 2), hx, 22.5);



  const cy = addrLines.length > 1 ? 29 : 26;



  doc.text(`Ph: ${settings.phone || C.phone}   |   ${settings.email || C.email}   |   ${settings.website || C.website}`, hx, cy);



  doc.setFontSize(5.8); doc.setTextColor(40, 50, 70);



  doc.text(`GST: ${settings.gstin || C.gstin}   |   MSME: ${settings.msme || C.msme}   |   LUT: ${settings.lut || C.lut} (${settings.lutDate || C.lutDate})`, hx, cy + 3.5);







  // Document badge — top right



  const bW = 42, bH = 13, bX = RM - bW - 2, bY = 13;



  doc.setFillColor(...NAVY);



  doc.roundedRect(bX, bY, bW, bH, 2, 2, 'F');



  doc.setFillColor(...GOLD);



  doc.rect(bX, bY + bH - 2.2, bW, 2.2, 'F');



  doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(...WHITE);



  doc.text(titleText, bX + bW / 2, bY + (bH - 2.2) / 2 + 0.5, { align: 'center', baseline: 'middle' });







  // Gold separator — moved down to avoid cutting info



  const finalH = 38;



  doc.setFillColor(...GOLD);



  doc.rect(LM, finalH, CW, 0.8, 'F');







  return finalH + 0.8;



}







// ─────────────────────────────────────────────────────────────────────────────



//  COMPACT PARTY + META  (3-column: Bill To | Ship To | Doc Details)



// ─────────────────────────────────────────────────────────────────────────────



function drawCompactPartyAndMeta(doc, order, startY, metaLeft, metaRight, metaHeader = 'INVOICE DETAILS') {



  const y = startY;



  const THIRD = CW / 3;



  const div1X = LM + THIRD;



  const div2X = LM + 2 * THIRD;



  const col1X = LM + 3;



  const col2X = div1X + 3;



  const col3X = div2X + 3;



  const colW = THIRD - 7;



  const SECTION_H = 42;  // increased from 34



  const HDR_HT = 7;      // increased from 6



  const PAD_VAL = 3;



  const LH_SZ = 4.5;     // increased from 4



  const LBL_W = 16;



  const VAL_W_COL = colW - LBL_W;







  // ── Header strip ──────────────────────────────────────────────────────────



  doc.setFillColor(...BGRAY);



  doc.rect(LM, y, CW, HDR_HT, 'F');







  // ── Vertical dividers ─────────────────────────────────────────────────────



  doc.setDrawColor(...LGRAY); doc.setLineWidth(0.2);



  doc.line(div1X, y, div1X, y + SECTION_H);



  doc.line(div2X, y, div2X, y + SECTION_H);







  // ── Column header labels ──────────────────────────────────────────────────



  doc.setFont('helvetica', 'bold'); doc.setFontSize(6); doc.setTextColor(...NAVY);



  doc.text('BILL TO', col1X, y + 3.9);



  doc.text('SHIP TO', col2X, y + 3.9);



  doc.text(metaHeader, col3X, y + 3.9);







  const clientNameVal = order.client_name || '';



  const billAddrVal = formatAddr(



    order.billing_address || order.client_address || order.client_address_derived,



    order.client_city, order.client_state, order.client_zip, order.client_country



  );



  const shipAddrVal = order.shipping_address



    ? formatAddr(order.shipping_address, order.client_city, order.client_state, order.client_zip, order.client_country)



    : billAddrVal;



  const phoneVal = order.client_phone || order.client_phone_derived || '';



  const shipLinesText = doc.splitTextToSize(shipAddrVal, colW);



  const metaPairsList = [];



  const maxMeta = Math.max(metaLeft.length, metaRight.length);



  for (let i = 0; i < maxMeta; i++) {



    if (metaLeft[i]) metaPairsList.push(metaLeft[i]);



    if (metaRight[i]) metaPairsList.push(metaRight[i]);



  }







  // ── Bill To ───────────────────────────────────────────────────────────────



  let by = y + HDR_HT + PAD_VAL;



  if (clientNameVal) {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5); doc.setTextColor(...DARK);



    doc.text(doc.splitTextToSize(clientNameVal, colW)[0], col1X, by); by += LH_SZ + 0.5;



  }



  doc.setFont('helvetica', 'normal'); doc.setFontSize(6.2); doc.setTextColor(...DARK);



  const billLinesArr = doc.splitTextToSize(billAddrVal, colW);



  billLinesArr.slice(0, 4).forEach(line => {



    doc.text(line, col1X, by);



    by += 3.5;



  });



  if (phoneVal) { doc.text(`Ph: ${phoneVal}`, col1X, by); by += 3.5; }



  const gstPartsRow = [



    order.client_gstin ? `GSTIN: ${order.client_gstin}` : null,



    order.client_state_code ? `State: ${order.client_state_code}` : null,



  ].filter(Boolean);



  if (gstPartsRow.length) {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(5.8); doc.setTextColor(...GRAY);



    doc.text(gstPartsRow.join('  |  '), col1X, by);



  }







  // ── Ship To ───────────────────────────────────────────────────────────────



  let sy = y + HDR_HT + PAD_VAL;



  if (clientNameVal) {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5); doc.setTextColor(...DARK);



    doc.text(doc.splitTextToSize(clientNameVal, colW)[0], col2X, sy); sy += LH_SZ + 0.5;



  }



  doc.setFont('helvetica', 'normal'); doc.setFontSize(6.2); doc.setTextColor(...DARK);



  shipLinesText.slice(0, 4).forEach(ln => { doc.text(ln, col2X, sy); sy += LH_SZ; });



  if (phoneVal) { doc.text(`Ph: ${phoneVal}`, col2X, sy); }







  // ── Meta column (label: value rows) ──────────────────────────────────────



  let iy = y + HDR_HT + PAD_VAL;



  const META_LH = metaPairsList.length > 6 ? 4.2 : 4.8;



  metaPairsList.forEach(([lbl, val]) => {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(6); doc.setTextColor(...GRAY);



    doc.text(lbl, col3X, iy);



    doc.setFont('helvetica', 'normal'); doc.setTextColor(...DARK);



    // Truncate value to fit in remaining column width



    const tv = doc.splitTextToSize(String(val), VAL_W_COL)[0];



    doc.text(tv, col3X + LBL_W, iy);



    iy += META_LH;



  });







  // ── Bottom border ─────────────────────────────────────────────────────────



  doc.setDrawColor(...LGRAY); doc.setLineWidth(0.2);



  doc.line(LM, y + SECTION_H, RM, y + SECTION_H);



  return y + SECTION_H;



}







// ─────────────────────────────────────────────────────────────────────────────



//  COMPACT ITEMS + SUMMARY  (tighter columns, Rate column added)



// ─────────────────────────────────────────────────────────────────────────────



function drawCompactItemsAndSummary(doc, order, startY, tots) {



  const W = doc.internal.pageSize.getWidth();



  const { tax } = tots;



  const cur = order.currency || 'USD';



  const items = order.items || [];







  const tableRows = items.map((it, i) => {



    const rowAmt = Number(it.total || 0);



    const unitPx = Number(it.unit_price || it.price || 0);



    const itemRate = getItemTaxRate(it, tax);



    const hsnSac = it.hsn_code || it.sac_code || '—';



    const metaParts = [];



    if (it.cas_number) metaParts.push(`CAS: ${it.cas_number}`);



    


    if (it.sac_code && !it.hsn_code) metaParts.push(`SAC: ${it.sac_code}`);



    const desc = [



      it.item_name || '—',



      metaParts.length ? metaParts.join(' | ') : '',



      it.pack_size ? `Pack: ${it.pack_size}` : '',



    ].filter(Boolean).join('\n');



    let taxCell;



    if (tax.isExport) {



      taxCell = 'LUT/Zero\nIGST@0%';



    } else if (tax.isIGST) {



      taxCell = `IGST@${itemRate}%\n${(rowAmt * itemRate / 100).toFixed(2)}`;



    } else {



      const half = itemRate / 2;



      taxCell = `CGST@${half}%: ${(rowAmt * half / 100).toFixed(2)}\nSGST@${half}%: ${(rowAmt * half / 100).toFixed(2)}`;



    }



    return [i + 1, desc, hsnSac, `${it.quantity || 1} Nos`, unitPx.toFixed(2), rowAmt.toFixed(2), taxCell];



  });







  // Pre-compute footer height



  const MIN_FOOTER_H = 44;



  let _sy = 5;



  const _inc = (bold = false) => { _sy += bold ? 6 : 4.2; };



  _inc();



  if (tots.freightAmt > 0) { _inc(); if (tots.freightGst > 0) _inc(); }



  _inc(); _inc();



  tots.charges.filter(c => Number(c.amount) > 0).forEach(c => { _inc(); if (Number(c.gst_pct) > 0) _inc(); });



  _inc(); _inc(true);



  _sy += 2; // extra spacing so Total Payable appears below separator line



  const FOOTER_H = Math.max(MIN_FOOTER_H, _sy + 5);



  const WORDS_H = 8;







  // Columns: SL#(8) + Desc(74) + HSN(15) + Qty(13) + Rate(22) + Amount(26) + Tax(32) = 190



  autoTable(doc, {



    startY,



    head: [['#', 'Item Description', 'HSN', 'Qty', 'Rate', 'Amount', 'Tax']],



    body: tableRows,



    margin: { left: LM, right: LM, top: 12, bottom: FOOTER_H + WORDS_H + 62 },



    styles: { fontSize: 7, cellPadding: [1.5, 2, 1.5, 2], lineColor: LGRAY, lineWidth: 0.2, textColor: DARK, valign: 'top' },



    headStyles: { fillColor: NAVY, textColor: WHITE, fontStyle: 'bold', fontSize: 7, halign: 'center', cellPadding: [2.5, 2, 2.5, 2] },



    alternateRowStyles: { fillColor: BGRAY },



    columnStyles: {



      0: { cellWidth: 8, halign: 'center' },



      1: { cellWidth: 74 },



      2: { cellWidth: 15, halign: 'center' },



      3: { cellWidth: 13, halign: 'center' },



      4: { cellWidth: 22, halign: 'right' },



      5: { cellWidth: 26, halign: 'right' },



      6: { cellWidth: 32, halign: 'right', fontSize: 6.5 },



    },



    theme: 'grid',



    didAddPage: (data) => drawPageBorder(data.doc),



  });







  let y = doc.lastAutoTable.finalY;







  // ── 2-col summary footer ──────────────────────────────────────────────────



  const splitX = LM + CW / 2;



  doc.setDrawColor(...LGRAY); doc.setLineWidth(0.2);



  doc.line(LM, y, RM, y);



  doc.line(splitX, y, splitX, y + FOOTER_H);



  doc.line(LM, y + FOOTER_H, RM, y + FOOTER_H);







  // Left: dispatch info



  const lx = LM + 3;



  const LVAL_X = lx + 30;                            // value starts here



  const LVAL_W = splitX - LVAL_X - 3;                // max width for value text



  let fy = y + 5.5;



  const drawL = (lbl, val) => {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(6.5); doc.setTextColor(...GRAY);



    doc.text(lbl, lx, fy);



    doc.setFont('helvetica', 'normal'); doc.setTextColor(...(val && val !== '—' ? DARK : GRAY));



    const tv = doc.splitTextToSize(val || '—', LVAL_W)[0];   // truncate to one line



    doc.text(tv, LVAL_X, fy);



    fy += 4.5;



  };



  drawL('Transport:', order.transport || '');



  drawL('Dispatch Doc:', order.dispatch_doc_number || '');



  drawL('Dated:', order.dispatch_doc_date ? fmtDate(order.dispatch_doc_date) : '');



  drawL('Destination:', order.destination || '');



  drawL('Terms of Del.:', order.terms_of_delivery || '');



  drawL('Freight:', order.freight_detail || '');



  if (order.additional_info) {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(6.5); doc.setTextColor(...GRAY);



    doc.text('Info:', lx, fy); fy += 3.5;



    doc.setFont('helvetica', 'normal'); doc.setFontSize(6.2); doc.setTextColor(...DARK);



    doc.text(doc.splitTextToSize(order.additional_info, splitX - lx - 4).slice(0, 3), lx, fy);



  }







  // Right: totals



  const rx = splitX + 3, vx = RM - 3;



  let sy = y + 4.5;



  const drawR = (lbl, val, bold = false) => {



    doc.setFont('helvetica', bold ? 'bold' : 'normal');



    doc.setFontSize(bold ? 8.5 : 7);



    doc.setTextColor(...(bold ? NAVY : GRAY));



    doc.text(lbl, rx, sy);



    doc.setTextColor(...(bold ? NAVY : DARK));



    doc.text(val, vx, sy, { align: 'right' });



    sy += bold ? 6 : 4.2;



  };



  drawR('Net Amount', tots.netAmt.toFixed(2));



  if (tots.freightAmt > 0) {



    drawR('Freight', tots.freightAmt.toFixed(2));



    if (tots.freightGst > 0)



      drawR(`  Freight GST (${Number(order.freight_gst_pct || 0).toFixed(1)}%)`, tots.freightGst.toFixed(2));



  }



  drawR('Net Tax', tots.netTax.toFixed(2));



  drawR('Gross Amount', tots.gross.toFixed(2));



  tots.charges.filter(c => Number(c.amount) > 0).forEach(c => {



    drawR(c.label || 'Other Charge', Number(c.amount).toFixed(2));



    if (Number(c.gst_pct) > 0)



      drawR(`  GST @${c.gst_pct}%`, (Number(c.amount) * Number(c.gst_pct) / 100).toFixed(2));



  });



  drawR('Rounding Off', `${tots.rounding >= 0 ? '+' : ''}${tots.rounding.toFixed(2)}`);







  // Total Payable separator + row



  doc.setDrawColor(...LGRAY); doc.setLineWidth(0.3);



  doc.line(splitX, sy + 2, RM, sy + 2);



  sy += 6;



  drawR('Total Payable', `${cur} ${tots.payable.toFixed(2)}`, true);







  y += FOOTER_H;







  // Amount in words bar



  const wordsText = formatAmountInWords(cur, tots.payable);



  doc.setFillColor(...NAVY);



  doc.roundedRect(LM, y, CW, WORDS_H, 2, 2, 'F');



  doc.setFillColor(...GOLD);



  doc.rect(LM, y, 3, WORDS_H, 'F');



  doc.rect(RM - 3, y, 3, WORDS_H, 'F');



  doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(...WHITE);



  const wLines = doc.splitTextToSize(wordsText, CW - 16);



  doc.text(wLines, W / 2, y + WORDS_H / 2 + (wLines.length > 1 ? -1.2 : 1.2), { align: 'center' });



  return y + WORDS_H;



}







// ─────────────────────────────────────────────────────────────────────────────



//  INVOICE PAGE



// ─────────────────────────────────────────────────────────────────────────────



async function drawInvoicePage(doc, order, copyLabel, logoDataUrl, settings = {}) {



  const tots = computeTotals(order);



  const isDraft = !['confirmed', 'delivered'].includes(order.status);



  const isCreditNote = order.order_type === 'credit_note';



  const titleBase = isCreditNote ? 'CREDIT NOTE' : 'TAX INVOICE';



  const title = copyLabel ? `${titleBase} — ${copyLabel}` : titleBase;



  const metaHeader = isCreditNote ? 'CREDIT NOTE DETAILS' : 'INVOICE DETAILS';



  const cur = order.currency || 'USD';







  const headerEnd = drawCompactHeader(doc, title, logoDataUrl, settings);



  const invoiceNo = order.invoice_number || '—';



  const metaEnd = drawCompactPartyAndMeta(doc, order, headerEnd,



    [



      ['Invoice No:', invoiceNo],



      ['PO Ref:', order.po_number || '—'],



      ['Waybill:', order.waybill_number || '—']



    ],



    [



      ['Date:', fmtDate(order.created_at || order.invoice_date)],



      ['PO Date:', fmtDate(order.po_date)],



      null, // empty spacer to keep sequence clean



      ['W. Date:', fmtDate(order.waybill_date)]



    ],



    metaHeader,



  );







  let y = drawCompactItemsAndSummary(doc, order, metaEnd, tots);







  // If bottom section (62 mm) won't fit on this page, start a new page



  const pageH = doc.internal.pageSize.getHeight();



  if (y + 65 > pageH - 12) {



    doc.addPage();



    drawPageBorder(doc);



    y = 14;



  }







  // Build QR data — plain text keeps the QR compact and scannable



  const qr1Text = [



    `INVOICE: ${order.invoice_number || '-'}`,



    `DATE: ${fmtDate(order.created_at)}`,



    `CLIENT: ${order.client_name || '-'}`,



    `TOTAL: ${tots.payable.toFixed(2)}`,



    `GSTIN: ${settings.gstin || '-'}`,



  ].join('\n');



  const showPayment = settings.showPaymentOnInvoice !== false;



  const paymentLink = (settings.paymentLink || C.paymentLink) + (order.invoice_number || '');



  const [qr1, qr2] = await Promise.all([



    generateQR(qr1Text),



    showPayment ? generateQR(paymentLink) : Promise.resolve(null),



  ]);







  await drawBottomSection(doc, order, y, false, settings, qr1, qr2);



  finalizePageFooters(doc, settings);



  if (isDraft) drawDraftWatermark(doc);



}







// ─────────────────────────────────────────────────────────────────────────────



//  PROFORMA INVOICE PAGE



// ─────────────────────────────────────────────────────────────────────────────



async function drawProformaPage(doc, order, logoDataUrl, settings = {}) {



  const tots = computeTotals(order);



  const isDraft = !['confirmed', 'delivered'].includes(order.status);



  const cur = order.currency || 'USD';







  const headerEnd = drawCompactHeader(doc, 'PROFORMA INVOICE', logoDataUrl, settings);



  const metaEnd = drawCompactPartyAndMeta(doc, order, headerEnd,



    [['Proforma No:', order.invoice_number || '—'], ['PO Ref:', order.po_number || '—']],



    [['Date:', fmtDate(order.created_at)], ['PO Date:', fmtDate(order.po_date)]],



    'PROFORMA DETAILS',



  );







  let y = drawCompactItemsAndSummary(doc, order, metaEnd, tots);







  // If bottom section (62 mm) won't fit on this page, start a new page



  const pageH = doc.internal.pageSize.getHeight();



  if (y + 65 > pageH - 12) {



    doc.addPage();



    drawPageBorder(doc);



    y = 14;



  }







  const qr1Text = [



    `PROFORMA: ${order.invoice_number || '-'}`,



    `DATE: ${fmtDate(order.created_at)}`,



    `CLIENT: ${order.client_name || '-'}`,



    `TOTAL: ${tots.payable.toFixed(2)}`,



  ].join('\n');



  const showPayment = settings.showPaymentOnInvoice !== false;



  const paymentLink = (settings.paymentLink || C.paymentLink) + (order.invoice_number || '');



  const [qr1, qr2] = await Promise.all([



    generateQR(qr1Text),



    showPayment ? generateQR(paymentLink) : Promise.resolve(null),



  ]);







  await drawBottomSection(doc, order, y, true, settings, qr1, qr2);



  finalizePageFooters(doc, settings);



  if (isDraft) drawDraftWatermark(doc);



}







// ─────────────────────────────────────────────────────────────────────────────



//  PURCHASE ORDER PAGE



// ─────────────────────────────────────────────────────────────────────────────



async function drawPurchaseOrderPage(doc, order, logoDataUrl, settings = {}) {



  const W = doc.internal.pageSize.getWidth();



  const tots = computeTotals(order);



  const { tax } = tots;



  const cur = order.currency || 'USD';



  const items = order.items || [];



  const isDraft = !['confirmed', 'delivered'].includes(order.status);







  drawCompanyHeader(doc, 'PURCHASE ORDER', logoDataUrl, settings);







  // ── Bill-to (left 55%) + PO info grid (right 45%) ────────────────────────



  const BILL_W = Math.round(CW * 0.55);   // 104 mm



  const infoX = LM + BILL_W;            // 114 mm



  const INFO_W = CW - BILL_W;             // 76 mm











  doc.setFillColor(...BGRAY);



  doc.rect(LM, 44, CW, 7, 'F');







  doc.setDrawColor(...LGRAY);



  doc.setLineWidth(0.2);



  doc.line(infoX, 44, infoX, 71);







  // Bill-to block



  const bx = LM + 3;



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(6.5);



  doc.setTextColor(...NAVY);



  doc.text('VENDOR / BILL TO', bx, 49);







  doc.setFont('helvetica', 'bold');



  doc.setFontSize(8.5);



  doc.setTextColor(...DARK);



  doc.text(doc.splitTextToSize(san(order.client_name), BILL_W - 6)[0], bx, 55);







  doc.setFont('helvetica', 'normal');



  doc.setFontSize(7);



  doc.setTextColor(...DARK);



  let byl = 59.5;



  if (order.client_email) { doc.text(san(order.client_email), bx, byl); byl += 4; }



  const fullShipAddr = formatAddr(



    order.shipping_address || order.billing_address || order.client_address || order.client_address_derived,



    order.client_city, order.client_state, order.client_zip, order.client_country



  );



  const shipLines = doc.splitTextToSize(san(fullShipAddr), BILL_W - 6);



  shipLines.slice(0, 5).forEach(line => {



    doc.text(line, bx, byl);



    byl += 3.5;



  });



  if (order.client_gstin) {



    doc.setFont('helvetica', 'bold'); doc.setTextColor(...DARK);



    doc.text(`GSTIN: ${san(order.client_gstin)}`, bx, byl);



  }







  // PO / Quote info grid (right panel) — 2 rows × 2 cols



  // Each cell: label on left, value right-aligned in cell



  const GRID_ROW_H = 13.5;



  const HALF_INFO = INFO_W / 2;           // 43mm each half



  const VAL_PAD = 2;



  const DIVX = infoX + HALF_INFO;    // vertical divider inside right panel











  const c1L = infoX + 2;



  const c1V = DIVX - 2;



  const c2L = DIVX + 2;







  [



    ['PO No.', order.invoice_number || '—', 'PO Date', fmtDate(order.po_date || order.order_created_at || order.created_at)],



    ['Quote No.', order.quote_number || '—', 'Quote Date', fmtDate(order.quote_date)],



  ].forEach(([l1, v1, l2, v2], i) => {



    const ry = 44 + i * GRID_ROW_H;



    if (i % 2 === 1) { doc.setFillColor(...BGRAY); doc.rect(infoX, ry, INFO_W, GRID_ROW_H, 'F'); }



    doc.setDrawColor(...LGRAY); doc.setLineWidth(0.2);



    doc.rect(infoX, ry, INFO_W, GRID_ROW_H);



    doc.line(DIVX, ry, DIVX, ry + GRID_ROW_H);







    const ty = ry + GRID_ROW_H / 2 + 1.5;



    doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(...GRAY);



    doc.text(l1, c1L, ty);



    doc.setFont('helvetica', 'normal'); doc.setTextColor(...DARK);



    doc.text(v1, c1V, ty, { align: 'right' });



    doc.setFont('helvetica', 'bold'); doc.setTextColor(...GRAY);



    doc.text(l2, c2L, ty);







    doc.setFont('helvetica', 'normal'); doc.setTextColor(...DARK);



    doc.text(doc.splitTextToSize(v2, HALF_INFO - 18)[0], infoX + INFO_W - VAL_PAD, ty, { align: 'right' });



  });







  doc.setDrawColor(...LGRAY);



  doc.setLineWidth(0.2);



  doc.line(LM, 71, RM, 71);







  // ── Items table ───────────────────────────────────────────────────────────



  // Column widths: 8+56+16+10+26+24+50 = 190 mm



  const taxHeader = tax.isExport



    ? 'Tax\n(LUT/Zero)'



    : tax.isIGST



      ? (tax.igst > 0 ? `Tax (IGST)\n${tax.igst}%` : 'Tax')



      : (tax.cgst > 0 ? `Tax (CGST+SGST)\n${tax.cgst}%+${tax.sgst}%` : 'Tax');







  const tableRows = items.map((it, i) => {



    const rowAmt = Number(it.total || 0);



    const itemRate = getItemTaxRate(it, tax);



    const hsnSac = it.hsn_code || it.sac_code || '—';



    const desc = [



      it.item_name || '—',



      it.cas_number ? `CAS: ${it.cas_number}` : '',



      it.pack_size ? `Pack: ${it.pack_size}` : '',



      it.sac_code && !it.hsn_code ? `SAC: ${it.sac_code}` : '',



    ].filter(Boolean).join('\n');



    let taxVal;



    if (tax.isExport) {



      taxVal = 'LUT/Zero\nIGST@0%';



    } else if (tax.isIGST) {



      taxVal = `IGST ${itemRate}%\n${(rowAmt * itemRate / 100).toFixed(2)}`;



    } else {



      const half = itemRate / 2;



      taxVal = `CGST: ${(rowAmt * half / 100).toFixed(2)}\nSGST: ${(rowAmt * half / 100).toFixed(2)}`;



    }



    return [



      i + 1, desc, hsnSac, `${it.quantity || 1} Nos`,



      `${Number(it.price || 0).toFixed(2)}`,



      `${rowAmt.toFixed(2)}`, taxVal,



    ];



  });







  // Pre-compute right-column height so footer box is sized correctly.



  const MIN_FOOTER_H_PO = 50;



  let _sy2 = 5;



  const _inc2 = (bold = false) => { _sy2 += bold ? 6 : 4.5; };



  _inc2(); _inc2(); // Net Amount, Freight



  if (tots.freightGst > 0) _inc2(); // Freight GST sub-line (conditional)



  _inc2(); _inc2(); // Net Tax, Gross Amount



  tots.charges.filter(c => Number(c.amount) > 0).forEach(c => {



    _inc2();



    if (Number(c.gst_pct) > 0) _inc2();



  });



  _inc2(); _inc2(true);



  _sy2 += 2; // extra spacing so Total Payable appears below separator line



  const FOOTER_H_PO = Math.max(MIN_FOOTER_H_PO, _sy2 + 5);



  const WORDS_H_PO = 10;







  autoTable(doc, {



    startY: 71,



    head: [['SL#', 'Item Description', 'HSN', 'Qty', 'Unit Price', 'Amount', taxHeader]],



    body: tableRows,



    margin: { left: LM, right: LM, top: 12, bottom: FOOTER_H_PO + WORDS_H_PO + 40 },



    styles: { fontSize: 7.5, cellPadding: [2, 2, 2, 2], lineColor: LGRAY, lineWidth: 0.2, textColor: DARK, valign: 'top' },



    headStyles: { fillColor: NAVY, textColor: WHITE, fontStyle: 'bold', fontSize: 7.5, halign: 'center' },



    alternateRowStyles: { fillColor: BGRAY },



    columnStyles: {



      0: { cellWidth: 10, halign: 'center', overflow: 'ellipsize' },



      1: { cellWidth: 56 },



      2: { cellWidth: 16, halign: 'center' },



      3: { cellWidth: 14, halign: 'center', overflow: 'ellipsize' },



      4: { cellWidth: 25, halign: 'right' },



      5: { cellWidth: 22, halign: 'right' },



      6: { cellWidth: 47, halign: 'right' },



    },



    theme: 'grid',



    didAddPage: (data) => drawPageBorder(data.doc),



  });



  let y = doc.lastAutoTable.finalY;







  // ── 2-column summary footer (height = FOOTER_H_PO, pre-computed above) ──────



  const SIG_H = 40;



  const splitX = LM + CW / 2;







  doc.setDrawColor(...LGRAY);



  doc.setLineWidth(0.2);



  doc.line(LM, y, RM, y);



  doc.line(splitX, y, splitX, y + FOOTER_H_PO);



  doc.line(LM, y + FOOTER_H_PO, RM, y + FOOTER_H_PO);







  // Left: freight notes



  const lx = LM + 3;



  const PVAL_X = lx + 32;



  const PVAL_W = splitX - PVAL_X - 3;



  let fy = y + 6;



  const drawL = (lbl, val) => {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(...GRAY); doc.text(lbl, lx, fy);



    doc.setFont('helvetica', 'normal'); doc.setTextColor(...(val && val !== '—' ? DARK : GRAY));



    const tv = doc.splitTextToSize(val && val !== '' ? String(val) : '—', PVAL_W)[0];



    doc.text(tv, PVAL_X, fy);



    fy += 5;



  };



  drawL('Transport:', order.transport || '');



  drawL('Dispatch Doc:', order.dispatch_doc_number || '');



  drawL('Dated:', order.dispatch_doc_date ? fmtDate(order.dispatch_doc_date) : '');



  drawL('Destination:', order.destination || '');



  drawL('Terms of Del.:', order.terms_of_delivery || '');



  drawL('Freight Detail:', order.freight_detail || '');



  if (order.additional_info) {



    doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(...GRAY);



    doc.text('Additional Info:', lx, fy); fy += 4;



    doc.setFont('helvetica', 'normal'); doc.setFontSize(6.8); doc.setTextColor(...DARK);



    doc.text(doc.splitTextToSize(order.additional_info, splitX - lx - 4).slice(0, 4), lx, fy);



  }







  // Right: totals



  const rx = splitX + 3;



  const vx = RM - 3;



  let sy = y + 5;



  const drawR = (lbl, val, bold = false) => {



    doc.setFont('helvetica', bold ? 'bold' : 'normal'); doc.setFontSize(bold ? 8.5 : 7.5);



    doc.setTextColor(...(bold ? NAVY : GRAY)); doc.text(lbl, rx, sy);



    doc.setTextColor(...(bold ? NAVY : DARK)); doc.text(val, vx, sy, { align: 'right' });



    sy += bold ? 6 : 4.5;



  };



  drawR('Net Amount', `${tots.netAmt.toFixed(2)}`);



  if (tots.freightAmt > 0) {



    drawR('Freight', `${tots.freightAmt.toFixed(2)}`);



    if (tots.freightGst > 0) {



      drawR(`  Freight GST (${Number(order.freight_gst_pct || 0).toFixed(1)}%)`, `${tots.freightGst.toFixed(2)}`);



    }



  }



  drawR('Net Tax', `${tots.netTax.toFixed(2)}`);



  drawR('Gross Amount', `${tots.gross.toFixed(2)}`);



  tots.charges.filter(c => Number(c.amount) > 0).forEach(c => {



    drawR(c.label || 'Other Charge', `${Number(c.amount).toFixed(2)}`);



    if (Number(c.gst_pct) > 0) {



      drawR(`  GST @${c.gst_pct}%`, `${(Number(c.amount) * Number(c.gst_pct) / 100).toFixed(2)}`);



    }



  });



  drawR('Rounding Off', `${tots.rounding >= 0 ? '+' : ''}${tots.rounding.toFixed(2)}`);







  // Total Payable row



  doc.setDrawColor(...LGRAY); doc.setLineWidth(0.3);



  doc.line(splitX, sy + 2, RM, sy + 2);



  sy += 6;



  drawR('Total Payable', `${tots.payable.toFixed(2)}`, true);



  y += FOOTER_H_PO;







  // ── Amount-in-words bar (anchored directly below Total Payable) ───────────



  const wordsTextPO = formatAmountInWords(cur, tots.payable);



  doc.setFillColor(...NAVY);



  doc.roundedRect(LM, y, CW, WORDS_H_PO, 2, 2, 'F');



  doc.setFillColor(...GOLD);



  doc.rect(LM, y, 3, WORDS_H_PO, 'F');



  doc.rect(RM - 3, y, 3, WORDS_H_PO, 'F');



  doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5); doc.setTextColor(...WHITE);



  const wLinesPO = doc.splitTextToSize(wordsTextPO, CW - 16);



  doc.text(wLinesPO, W / 2, y + WORDS_H_PO / 2 + (wLinesPO.length > 1 ? -1.5 : 1.5), { align: 'center' });



  y += WORDS_H_PO;







  // ── Signature section (PO: right-aligned, with QR codes) ─────────────────



  const qrSize = 18;



  const col2X = LM + 65;



  const col3X = LM + 115;







  doc.setDrawColor(...LGRAY); doc.setLineWidth(0.2);



  doc.line(col2X, y, col2X, y + SIG_H);



  doc.line(col3X, y, col3X, y + SIG_H);



  doc.line(LM, y + SIG_H, RM, y + SIG_H);







  // Terms column (left of PO sig section)



  let py2 = y + 5;



  const pTerms = [



    'Goods are subject to approval on receipt.',



    'PRASI LABS reserves the right to reject.',



    'Subject to Hyderabad (India) jurisdiction.',



  ];



  doc.setFont('helvetica', 'normal'); doc.setFontSize(6.5); doc.setTextColor(...GRAY);



  pTerms.forEach(t => {



    const tl = doc.splitTextToSize(t, 60);



    doc.text(tl, LM + 3, py2);



    py2 += tl.length * 3.5 + 1;



  });







  // QR column



  const qr1Text = [



    'PURCHASE ORDER',



    `No: ${order.invoice_number || '—'}`,



    `Date: ${fmtDate(order.created_at)}`,



    `Vendor: ${order.client_name || '—'}`,



    `Total: ${tots.payable.toFixed(2)}`,



    `Issued By: ${settings.name || 'PRASI LABS'}`,



  ].join('\n');



  const [qr1] = await Promise.all([generateQR(qr1Text)]);











  let qy = y + 4;



  doc.setFont('helvetica', 'bold'); doc.setFontSize(5.8); doc.setTextColor(...NAVY);



  doc.text('ORDER INFO', col2X + 25, qy, { align: 'center' });



  qy += 3;



  if (qr1) doc.addImage(qr1, 'PNG', col2X + (50 - qrSize) / 2, qy, qrSize, qrSize);



  qy += qrSize + 1.5;



  doc.setFont('helvetica', 'normal'); doc.setFontSize(5.5); doc.setTextColor(...GRAY);



  doc.text('Scan for details', col2X + 25, qy, { align: 'center' });







  // Signature column



  let by = y + 5;



  doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(...DARK);



  doc.text(`For ${settings.name || C.name}`, vx, by, { align: 'right' });



  by += 2;







  const boxW = 65;



  doc.setDrawColor(...GRAY); doc.setLineDashPattern([2, 1], 0);



  doc.roundedRect(RM - 3 - boxW, by, boxW, 13, 2, 2);



  doc.setLineDashPattern([], 0);



  by += 15;



  doc.setFont('helvetica', 'normal'); doc.setFontSize(6.5); doc.setTextColor(...GRAY);



  doc.text('Authorized Signatory', RM - 3 - boxW / 2, by, { align: 'center' });







  finalizePageFooters(doc, settings);



  if (isDraft) drawDraftWatermark(doc);



}







// ─────────────────────────────────────────────────────────────────────────────



//  PUBLIC API



// ─────────────────────────────────────────────────────────────────────────────







export async function generateInvoicePDF(order, options = {}) {



  const copies = options.copies || ['ORIGINAL'];



  const [logoDataUrl, settings] = await Promise.all([loadLogoBase64(), loadCompanySettings()]);



  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });



  for (let i = 0; i < copies.length; i++) {



    if (i > 0) doc.addPage();



    await drawInvoicePage(doc, order, copies[i], logoDataUrl, settings);



  }



  const fileNum = order.invoice_number || 'invoice';



  doc.save(`${fileNum.replace(/[^a-zA-Z0-9-]/g, '_')}_invoice.pdf`);



}







export async function generateSingleInvoicePDF(order, copyLabel = 'ORIGINAL') {



  const [logoDataUrl, settings] = await Promise.all([loadLogoBase64(), loadCompanySettings()]);



  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });



  await drawInvoicePage(doc, order, copyLabel, logoDataUrl, settings);



  doc.save(`${(order.invoice_number || 'invoice').replace(/[^a-zA-Z0-9-]/g, '_')}_${copyLabel.toLowerCase()}.pdf`);



}







export async function generateProformaInvoicePDF(order) {



  const [logoDataUrl, settings] = await Promise.all([loadLogoBase64(), loadCompanySettings()]);



  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });



  await drawProformaPage(doc, order, logoDataUrl, settings);



  doc.save(`${(order.invoice_number || 'proforma').replace(/[^a-zA-Z0-9-]/g, '_')}_proforma.pdf`);



}







export async function generatePurchaseOrderPDF(order) {



  const [logoDataUrl, settings] = await Promise.all([loadLogoBase64(), loadCompanySettings()]);



  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });



  await drawPurchaseOrderPage(doc, order, logoDataUrl, settings);



  doc.save(`${(order.invoice_number || 'po').replace(/[^a-zA-Z0-9-]/g, '_')}_purchase_order.pdf`);



}







// Credit note uses the same compact invoice layout with red "CREDIT NOTE" badge



export async function generateCreditNotePDF(order) {



  const [logoDataUrl, settings] = await Promise.all([loadLogoBase64(), loadCompanySettings()]);



  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });



  await drawInvoicePage(doc, order, 'ORIGINAL', logoDataUrl, settings);



  doc.save(`${(order.invoice_number || 'cn').replace(/[^a-zA-Z0-9-]/g, '_')}_credit_note.pdf`);



}







// ─────────────────────────────────────────────────────────────────────────────



//  QUOTATION (inquiry-based, navy/teal theme)



// ─────────────────────────────────────────────────────────────────────────────



export async function generateQuotePDF(inq) {



  const [logoDataUrl, settings] = await Promise.all([loadLogoBase64(), loadCompanySettings()]);



  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });



  const W = doc.internal.pageSize.getWidth();



  const H = doc.internal.pageSize.getHeight();



  const cur = inq.currency || 'INR';







  // ── 1. Calculate Totals (matching frontend logic) ─────────────────────────



  const items = (inq.items || []).map(it => {



    const lineSubtotal = (Number(it.price) || 0) * (Number(it.quantity) || 0);



    const lineDiscount = lineSubtotal * (Number(it.discount_percent || 0) / 100);



    const lineTaxable = lineSubtotal - lineDiscount;



    const globalDiscPct = Number(inq.discount_percent || 0);



    const finalTaxable = lineTaxable * (1 - globalDiscPct / 100);



    const lineGst = finalTaxable * (Number(it.gst_rate || 0) / 100);



    return { ...it, total: lineTaxable, finalTaxable, lineGst };



  });







  const netAmt = items.reduce((s, it) => s + it.finalTaxable, 0);

  const netTax = items.reduce((s, it) => s + it.lineGst, 0);

  const freight = Number(inq.freight_amount) || 0;



  // Special freight calculation for quotations: (Net amount + freight) + 18% GST on entire sum

  let gross, payable, rounding;

  if (freight > 0) {

    // Apply 18% GST on (Net amount + freight)

    const amountWithFreight = netAmt + freight;

    gross = amountWithFreight * 1.18;

    payable = Math.round(gross);

    rounding = payable - gross;

  } else {

    // Normal calculation without freight

    gross = netAmt + netTax;

    payable = Math.round(gross);

    rounding = payable - gross;

  }



  const tots = { netAmt, netTax, freight, gross, rounding, payable, items };







  // ── 2. Derive Tax Type (Inter vs Intra state) ─────────────────────────────



  // Dummy check: if we have GSTINs, compare first 2 chars



  const companyStateCode = (settings.gstin || C.gstin || '').substring(0, 2);



  const clientStateCode = (inq.client_state_code || '').substring(0, 2);



  let isIGST = false;



  if (clientStateCode && companyStateCode && clientStateCode !== companyStateCode) {



    isIGST = true;



  }







  // ── 3. Draw Header ────────────────────────────────────────────────────────



  drawCompanyHeader(doc, 'QUOTATION', logoDataUrl, settings);







  // ── 5. Metadata Grid (4-column layout) ────────────────────────────────────



  const metaRows = [



    ['Quotation No', ` ${inq.inquiry_number || '—'}`, 'Payment Terms', ` ${inq.payment_terms || '100% Advance with Purchase'}`],



    ['Quotation Date', ` ${fmtDate(inq.inquiry_date || inq.created_at)}`, 'Customer Name', ` ${inq.client_name || '—'}`],



    ['Quotation Expiry Date', ` ${inq.quote_expiry_date ? fmtDate(inq.quote_expiry_date) : '—'}`, 'User', ` ${inq.assigned_to_name || '—'}`],



    ['Reference#', ` ${inq.reference_number || '—'}`, '', ''],



  ];







  autoTable(doc, {



    startY: 48,



    body: metaRows,



    margin: { left: LM, right: LM },



    styles: { fontSize: 7.5, cellPadding: 2, lineColor: LGRAY, lineWidth: 0.1, textColor: DARK, valign: 'middle' },



    columnStyles: {



      0: { cellWidth: 35, fontStyle: 'normal', textColor: GRAY },



      1: { cellWidth: 60, fontStyle: 'bold' },



      2: { cellWidth: 35, fontStyle: 'normal', textColor: GRAY },



      3: { cellWidth: 60, fontStyle: 'bold' },



    },



    theme: 'grid',



    alternateRowStyles: { fillColor: BGRAY },



  });







  let y = doc.lastAutoTable.finalY + 5;







  // ── 6. Billing Address ────────────────────────────────────────────────────



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(7);



  doc.setTextColor(...GRAY);



  doc.text('BILLING ADDRESS', LM + 3, y);



  y += 5;







  // Client name as bold title



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(8.5);



  doc.setTextColor(...DARK);



  const clientName = inq.client_name || '—';



  const nameLines = doc.splitTextToSize(clientName, CW - 10);



  doc.text(nameLines, LM + 3, y);



  y += nameLines.length * 4.2;







  // Rest of address in normal



  doc.setFont('helvetica', 'normal');



  doc.setFontSize(8);



  const addrParts = formatAddr(inq.billing_address, inq.client_city, inq.client_state, inq.client_zip, inq.client_country);







  if (addrParts) {



    const addrLines = doc.splitTextToSize(addrParts, CW - 10);



    doc.text(addrLines, LM + 3, y);



    y += addrLines.length * 4 + 2;



  } else {

    y += 2;

  }



  // ── Contact Info ──────────────────────────

  const cPers = inq.contact_name || inq.client_attention_to || '';

  const cEm = inq.contact_email || inq.client_email || '';

  const cPh = inq.contact_phone || inq.client_phone || '';



  if (cPers || cEm || cPh) {

    doc.setFontSize(8);

    doc.setTextColor(60, 60, 60);



    if (cPers) {

      doc.text(`Attn: ${cPers}`, LM + 3, y);

      y += 4.2;

    }

    if (cEm) {

      doc.text(`Email: ${cEm}`, LM + 3, y);

      y += 4.2;

    }

    if (cPh) {

      doc.text(`Ph: ${cPh}`, LM + 3, y);

      y += 4.2;

    }

    y += 2;

  }









  // ── 7. Items Table ────────────────────────────────────────────────────────

  // Items Table with enhanced descriptions

  const tableRows = items.map((it, i) => {

    const hsnSac = it.hsn_code || it.sac_code || '---';

    const rate = Number(it.price) || 0;

    const amount = it.total || 0;



    // Build comprehensive item description

    const descParts = [it.item_name || '---'];



    // Add technical details

    const techDetails = [];

    if (it.cas_number) techDetails.push(`CAS: ${it.cas_number}`);

    if (it.catalog_number) techDetails.push(`Cat No: ${it.catalog_number}`);

    if (it.molecular_formula) techDetails.push(`Formula: ${it.molecular_formula}`);

    if (it.molecular_weight) techDetails.push(`MW: ${it.molecular_weight}`);

    if (it.pharmacopeia) techDetails.push(`Pharm: ${it.pharmacopeia}`);



    if (techDetails.length > 0) {

      descParts.push(techDetails.join(' | '));

    }



    // Add packaging and logistics info

    const packDetails = [];

    if (it.pack_size) packDetails.push(`Pack: ${it.pack_size}`);

    if (it.storage) packDetails.push(`Storage: ${it.storage}`);

    if (it.lead_time) packDetails.push(`Lead: ${it.lead_time}`);



    if (packDetails.length > 0) {

      descParts.push(packDetails.join(' | '));

    }



    // Add description if available

    if (it.description) {

      descParts.push(`Description: ${it.description}`);

    }



    const desc = descParts.join('\n');





    let taxCell;



    const itemRate = Number(it.gst_rate || 0);



    if (isIGST) {



      taxCell = `IGST@${itemRate}%: ${it.lineGst.toFixed(2)}`;



    } else {



      const half = itemRate / 2;



      taxCell = `CGST@${half}%: ${(it.lineGst / 2).toFixed(2)}\nSGST@${half}%: ${(it.lineGst / 2).toFixed(2)}`;



    }



    return [i + 1, desc, hsnSac, `${it.quantity || 1} Nos`, rate.toFixed(2), amount.toFixed(2), taxCell];



  });







  // Footer height includes summary + words bar + notes



  const MIN_FOOTER_H = 45;



  const WORDS_H = 10;



  autoTable(doc, {



    startY: y,



    head: [['#', 'Item Description', 'HSN', 'Qty', 'Rate', 'Amount', 'Tax']],



    body: tableRows,



    margin: { left: LM, right: LM, bottom: MIN_FOOTER_H + WORDS_H + 30 },



    styles: { fontSize: 7.5, cellPadding: 2, lineColor: LGRAY, lineWidth: 0.2, textColor: DARK, valign: 'top' },



    headStyles: { fillColor: NAVY, textColor: WHITE, fontStyle: 'bold', fontSize: 7.5, halign: 'center' },



    alternateRowStyles: { fillColor: [255, 255, 255] },



    columnStyles: {



      0: { cellWidth: 8, halign: 'center' },



      1: { cellWidth: 70 },



      2: { cellWidth: 20, halign: 'center' },



      3: { cellWidth: 15, halign: 'center' },



      4: { cellWidth: 22, halign: 'right' },



      5: { cellWidth: 22, halign: 'right', fontStyle: 'bold' },



      6: { cellWidth: 33, halign: 'right', fontSize: 6.5 },



    },



    theme: 'grid',



    didAddPage: (data) => drawPageBorder(data.doc),



  });







  y = doc.lastAutoTable.finalY;







  // ── 8. Summary Section ────────────────────────────────────────────────────



  const splitX = LM + CW / 2;



  const rx = splitX + 3;



  const vx = RM - 3;



  let sy = y + 5;







  const drawR = (lbl, val, bold = false) => {



    doc.setFont('helvetica', bold ? 'bold' : 'normal');



    doc.setFontSize(bold ? 8.5 : 7.5);



    doc.setTextColor(...(bold ? NAVY : GRAY));



    doc.text(lbl, rx, sy);



    doc.setTextColor(...(bold ? NAVY : DARK));



    doc.text(val, vx, sy, { align: 'right' });



    sy += bold ? 6 : 4.5;



  };







  drawR('Net Amount', tots.netAmt.toFixed(2));

  drawR('Freight Amount', tots.freight.toFixed(2));

  drawR('Net Tax', tots.netTax.toFixed(2));

  drawR('Gross Amount', tots.gross.toFixed(2));

  drawR('Rounding Off', `${tots.rounding >= 0 ? '+' : ''}${tots.rounding.toFixed(2)}`);







  doc.setDrawColor(...LGRAY); doc.setLineWidth(0.2);



  doc.line(splitX, sy, RM, sy);



  sy += 5;



  drawR('Total Payable', `${cur}${tots.payable.toFixed(2)}`, true);







  y = sy + 4;







  // ── 9. Amount in Words Bar ────────────────────────────────────────────────



  const wordsText = `AMOUNT: ${numberToWords(tots.payable)} RUPEES ONLY`;



  doc.setFillColor(...NAVY);



  doc.roundedRect(LM, y, CW, WORDS_H, 2, 2, 'F');



  doc.setFillColor(...GOLD);



  doc.rect(LM, y, 3, WORDS_H, 'F');



  doc.rect(RM - 3, y, 3, WORDS_H, 'F');



  doc.setFont('helvetica', 'bold');



  doc.setFontSize(7.5);



  doc.setTextColor(...WHITE);



  const wLines = doc.splitTextToSize(wordsText, CW - 16);



  doc.text(wLines, W / 2, y + WORDS_H / 2 + (wLines.length > 1 ? -1.5 : 1.5), { align: 'center' });







  y += WORDS_H + 5;







  // ── 10. Inquiry Details & Requirements ────────────────────────────────────────────────



  // Add inquiry details section if available

  if (inq.details || inq.notes || inq.subject) {

    doc.setFont('helvetica', 'bold');

    doc.setFontSize(8);

    doc.setTextColor(...NAVY);

    doc.text('INQUIRY DETAILS & REQUIREMENTS', LM + 3, y);

    y += 6;



    doc.setFont('helvetica', 'normal');

    doc.setFontSize(7.5);

    doc.setTextColor(...DARK);



    // Subject



    // Details / Description

    if (inq.details) {

      const detailsLines = doc.splitTextToSize(`Details / Description: ${inq.details}`, CW - 6);

      doc.text(detailsLines, LM + 3, y);

      y += detailsLines.length * 4 + 2;

    }



    //Internal Notes: 

    if (inq.notes) {

      const notesLines = doc.splitTextToSize(`Internal Notes: ${inq.notes}`, CW - 6);

      doc.text(notesLines, LM + 3, y);

      y += notesLines.length * 4 + 2;

    }



    y += 4; // Extra spacing before next section

  }







  // ── 11. Note & Terms ──────────────────────────────────────────────────────



  const note = 'Note: DSIR - GST Exemption certificate has to be provided along with the PO to claim GST @ 5% In absence of exemption certificate GST would charged extra @ 18%.';



  doc.setFont('helvetica', 'normal');



  doc.setFontSize(7.5);



  doc.setTextColor(...DARK);



  const noteLines = doc.splitTextToSize(note, CW - 6);



  doc.text(noteLines, LM + 3, y);



  y += noteLines.length * 4 + 6;







  doc.setFont('helvetica', 'bold');



  doc.text('Terms & Conditions', LM + 3, y);



  y += 4;



  doc.setFont('helvetica', 'normal');



  const terms = [

    '1. Prices are valid for 30 days from quotation date unless specified otherwise.',

    '2. Packing & forwarding charges upto your stores at Hyderabad would be borne by us.',

    '3. All products are supplied with Certificate of Analysis (CoA).',

    '4. Delivery timeline: 1-2 weeks for ready stock, 4-8 weeks for custom synthesis.',

    '5. Payment terms as specified above or 100% advance with purchase order.',

    '6. Goods once sold cannot be taken back or exchanged.',

    '7. Subject to Hyderabad jurisdiction. E&OE.'

  ];



  terms.forEach(term => {

    const termLines = doc.splitTextToSize(term, CW - 6);

    doc.text(termLines, LM + 3, y);

    y += termLines.length * 4 + 1;

  });







  finalizePageFooters(doc, settings);







  // ── 11. Custom Professional Footer ────────────────────────────────────────



  const footerY = H - 14;



  doc.setFont('helvetica', 'normal');



  doc.setFontSize(7.5);



  doc.setTextColor(140, 140, 140);



  doc.text(`Computer-generated document. Page 1 of 1`, LM, footerY);







  const genDate = new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });



  doc.text(`Generated: ${genDate} | ${settings.website || 'www.prasilabs.com'}`, RM, footerY, { align: 'right' });







  // QR Code for Quote Validation



  const qrText = [



    'QUOTATION VALIDATION',



    `Ref: ${inq.inquiry_number || '—'}`,



    `Date: ${fmtDate(inq.inquiry_date || inq.created_at)}`,



    `To: ${inq.client_name || '-'}`,



    `Amt: ${tots.payable.toFixed(2)}`,



    `Vendor: PRASI LABS`



  ].join('\n');



  const qrDU = await generateQR(qrText);



  if (qrDU) {



    doc.addImage(qrDU, 'PNG', RM - 22, footerY - 24, 20, 20);



  }







  // Navy Bottom Strip



  doc.setFillColor(...NAVY);



  doc.rect(0, H - 8, W, 8, 'F');



  doc.setFont('helvetica', 'normal');



  doc.setFontSize(7.5);



  doc.setTextColor(210, 220, 240);



  const bottomText = `${settings.name || 'PRASI LABS PRIVATE LIMITED'} | Hyderabad, India | ${settings.website || 'www.prasilabs.com'}`;



  doc.text(bottomText, W / 2, H - 3.2, { align: 'center' });







  doc.save(`${(inq.inquiry_number || 'quote').replace(/[^a-zA-Z0-9-]/g, '_')}_quotation.pdf`);



}











// ─────────────────────────────────────────────────────────────────────────────



//  CERTIFICATE OF ANALYSIS  — Professional Pharma Format



// ─────────────────────────────────────────────────────────────────────────────



export async function generateCOAPDF(coa) {



  // Load all assets in parallel



  const toB64 = async (url) => {



    try {



      const res = await fetch(url);



      if (!res.ok) return null;



      const blob = await res.blob();



      return await new Promise(resolve => {



        const r = new FileReader();



        r.onloadend = () => resolve(r.result);



        r.readAsDataURL(blob);



      });



    } catch { return null; }



  };







  const [logoDataUrl, startupIndiaUrl, makeInIndiaUrl] = await Promise.all([



    toB64('/prasilabs-logo.png'),



    toB64('/about/startup.png'),



    toB64('/about/accreditations/made-in-india.jpg'),



  ]);







  // Generate QR code encoding key COA details



  const qrText = [



    `COA: ${coa.coa_number || ''}`,



    `Product: ${coa.product_name || ''}`,



    coa.cas_number ? `CAS#: ${coa.cas_number}` : '',



    coa.catalog_number ? `Catalog#: ${coa.catalog_number}` : '',



    '',



    coa.date_of_analysis ? `Analysed: ${fmtDate(coa.date_of_analysis)}` : '',



    coa.retest_date ? `Retest: ${fmtDate(coa.retest_date)}` : '',



    `Status: ${coa.status || 'draft'}`,



  ].filter(Boolean).join('\n');



  const coaQrDataUrl = await generateQR(qrText, { width: 300, margin: 1 });







  // Load structure/product image if present



  let structureImageDataUrl = null;



  if (coa.structure_image) {

    try {

      const res = await fetch(getCoaImageUrl(coa.structure_image));



      const blob = await res.blob();



      structureImageDataUrl = await new Promise(resolve => {



        const r = new FileReader();



        r.onloadend = () => resolve(r.result);



        r.readAsDataURL(blob);



      });



    } catch { /* skip */ }



  }







  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });



  const W = doc.internal.pageSize.getWidth();   // 210



  const H = doc.internal.pageSize.getHeight();  // 297



  const ML = 11, MR = 11;



  const CW = W - ML - MR;                        // 188 mm usable







  // Colour tokens



  const NAVY_COA = [10, 36, 99];



  const LABEL_BG = [232, 238, 250];



  const HDR_BG = [10, 36, 99];



  const BORDER_C = [180, 190, 210];



  const VAL_TEXT = [25, 25, 25];



  const SUB_TEXT = [80, 80, 80];



  const GREEN_SI = [14, 110, 58];



  const ORANGE_MI = [200, 80, 0];



  const GOLD_BAR = [242, 162, 0];







  const today = fmtDate(new Date().toISOString());







  // Helper: draw the outer page border (called on every page)



  const drawPageBorder = () => {



    doc.setDrawColor(...BORDER_C); doc.setLineWidth(0.4);



    doc.roundedRect(ML - 2, 5, CW + 4, H - 10, 3, 3);



  };







  // Helper: draw the navy bottom strip on the current page



  const drawBottomStrip = () => {



    doc.setFillColor(...NAVY_COA);



    doc.rect(0, H - 8, W, 8, 'F');



    doc.setFont('helvetica', 'bold'); doc.setFontSize(6.5); doc.setTextColor(180, 205, 240);



    doc.text(



      'PRASI LABS PVT LIMITED  ·  Hyderabad, India  ·  www.prasilabs.com  ·  info@prasilabs.com',



      W / 2, H - 2.8, { align: 'center' }



    );



  };







  drawPageBorder();







  /* ═══════════════════════════════════════════════════════════════



     1.  TOP HEADER — PRASI logo | Startup India logo | Make in India logo



         Header zone: y=6..24 (18 mm).



         Startup India PNG is wide (≈3.2:1) → 44×14 mm



         Make in India JPG is landscape (≈1.78:1) → 28×16 mm



  ═══════════════════════════════════════════════════════════════ */



  // PRASI logo (left)



  if (logoDataUrl) {



    try { doc.addImage(logoDataUrl, 'PNG', ML, 7, 32, 15); } catch { /* skip */ }



  }







  // Startup India logo (centre)



  if (startupIndiaUrl) {



    try { doc.addImage(startupIndiaUrl, 'PNG', W / 2 - 22, 7, 44, 14); } catch { /* skip */ }



  } else {



    // Fallback text if image unavailable



    doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5); doc.setTextColor(...GREEN_SI);



    doc.text('#startupindia', W / 2, 15, { align: 'center' });



  }



  doc.setFont('helvetica', 'normal'); doc.setFontSize(5.2); doc.setTextColor(...SUB_TEXT);



  doc.text('Recognized by DPIIT, Govt. of India', W / 2, 23, { align: 'center' });







  // Make in India logo (right)



  if (makeInIndiaUrl) {



    try { doc.addImage(makeInIndiaUrl, 'JPEG', W - MR - 30, 7, 28, 16); } catch { /* skip */ }



  } else {



    // Fallback text if image unavailable



    doc.setFont('helvetica', 'bold'); doc.setFontSize(8); doc.setTextColor(...ORANGE_MI);



    doc.text('MAKE IN INDIA', W - MR - 15, 15, { align: 'center' });



  }







  // Divider



  doc.setDrawColor(...BORDER_C); doc.setLineWidth(0.3);



  doc.line(ML - 2, 25, W - MR + 2, 25);







  /* ═══════════════════════════════════════════════════════════════



     2.  ACCREDITATION BAND — 8 mm, starts at y=25



  ═══════════════════════════════════════════════════════════════ */



  let y = 26;



  doc.setFillColor(245, 247, 252);



  doc.rect(ML - 2, y, CW + 4, 8, 'F');



  doc.setFont('helvetica', 'bold'); doc.setFontSize(6.5); doc.setTextColor(...NAVY_COA);



  doc.text(



    'Quality Accreditations: ISO 9001:2015  |  ISO 14001:2015  |  ISO17034:2016  |  ISO/IEC 17025:2017',



    W / 2, y + 3, { align: 'center' }



  );



  doc.setFont('helvetica', 'normal'); doc.setFontSize(5.8); doc.setTextColor(...SUB_TEXT);



  doc.text(



    'Start-up India.  Only for R&D & analytical purpose.  Not meant for human consumption.',



    W / 2, y + 6.5, { align: 'center' }



  );



  y += 9;







  /* ═══════════════════════════════════════════════════════════════



     3.  "CERTIFICATE OF ANALYSIS" TITLE BAR — 7 mm



  ═══════════════════════════════════════════════════════════════ */



  doc.setFillColor(...HDR_BG);



  doc.rect(ML - 2, y, CW + 4, 7, 'F');



  doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(255, 255, 255);



  doc.text('CERTIFICATE OF ANALYSIS', W / 2, y + 5, { align: 'center' });



  y += 8;   // 7mm bar + 1mm gap → y ≈ 39







  /* ═══════════════════════════════════════════════════════════════



     4.  PRODUCT INFORMATION TABLE



         Columns: labelA(44) | valueA(49) | labelB(44) | valueB(49) = 186mm



         Compact cell padding: top/bottom 1.5 → row ≈ 5.5 mm × 8 rows ≈ 44 mm



  ═══════════════════════════════════════════════════════════════ */



  const LW = 44, VW = 49;







  const lbStyle = (txt) => ({



    content: txt,



    styles: {



      fillColor: LABEL_BG, textColor: NAVY_COA, fontStyle: 'bold',



      fontSize: 7.2, cellPadding: { top: 1.5, bottom: 1.5, left: 3, right: 2 },



      lineColor: BORDER_C, lineWidth: 0.2,



    },



  });



  const valStyle = (txt, span = 1) => ({



    content: String(txt || '—'),



    colSpan: span,



    styles: {



      fillColor: [255, 255, 255], textColor: VAL_TEXT, fontStyle: 'normal',



      fontSize: 7.2, cellPadding: { top: 1.5, bottom: 1.5, left: 3, right: 2 },



      lineColor: BORDER_C, lineWidth: 0.2,



    },



  });







  const infoBody = [



    [lbStyle('Product Name'), valStyle(sanPdf(coa.product_name), 3)],



    [lbStyle('IUPAC Name'), valStyle(sanPdf(coa.iupac_name), 3)],



    [lbStyle('CAS#'), valStyle(sanPdf(coa.cas_number), 3)],



    [lbStyle('Catalog#'), valStyle(sanPdf(coa.catalog_number))],



    [lbStyle('Mol. Formula'), valStyle(sanPdf(coa.molecular_formula)), lbStyle('Mol. Weight'), valStyle(sanPdf(coa.molecular_weight))],



    [lbStyle('Date of Analysis'), valStyle(fmtDate(coa.date_of_analysis)), lbStyle('Retest Date'), valStyle(fmtDate(coa.retest_date))],



    [lbStyle('Storage Conditions'), valStyle(sanPdf(coa.storage_conditions), 3)],



    [lbStyle('Shipping Conditions'), valStyle(sanPdf(coa.shipping_conditions), 3)],



  ];







  autoTable(doc, {



    startY: y,



    body: infoBody,



    theme: 'plain',



    tableLineColor: BORDER_C, tableLineWidth: 0.2,



    margin: { left: ML - 2, right: MR - 2 },



    columnStyles: { 0: { cellWidth: LW }, 1: { cellWidth: VW }, 2: { cellWidth: LW }, 3: { cellWidth: VW } },



    didAddPage: () => { drawPageBorder(); drawBottomStrip(); },



  });



  y = doc.lastAutoTable.finalY + 2;







  /* ═══════════════════════════════════════════════════════════════



     4b. STRUCTURE IMAGE — placed right of product table if space,



         else centered below. Max 30 mm tall.



  ═══════════════════════════════════════════════════════════════ */



  if (structureImageDataUrl) {



    const IMG_H = 28;   // total box height (label 5 + image 23)



    const IMG_W = 60;



    const imgBoxX = ML - 2 + (CW + 4 - IMG_W) / 2;







    // Label bar



    doc.setFillColor(...LABEL_BG);



    doc.rect(imgBoxX, y, IMG_W, 5, 'F');



    doc.setDrawColor(...BORDER_C); doc.setLineWidth(0.2);



    doc.rect(imgBoxX, y, IMG_W, IMG_H);



    doc.setFont('helvetica', 'bold'); doc.setFontSize(6.5); doc.setTextColor(...NAVY_COA);



    doc.text('Chemical Structure / Product Image', W / 2, y + 3.5, { align: 'center' });







    try {



      const imgFmt = structureImageDataUrl.startsWith('data:image/png') ? 'PNG'



        : structureImageDataUrl.startsWith('data:image/gif') ? 'GIF'



          : 'JPEG';



      const props = doc.getImageProperties(structureImageDataUrl);



      const maxW = IMG_W - 2;



      const maxH = IMG_H - 7;



      const ratio = props.width / props.height;



      let drawW, drawH;



      if (ratio > maxW / maxH) {



        drawW = maxW;



        drawH = maxW / ratio;



      } else {



        drawH = maxH;



        drawW = maxH * ratio;



      }



      const drawX = imgBoxX + 1 + (maxW - drawW) / 2;



      const drawY = y + 6 + (maxH - drawH) / 2;



      doc.addImage(structureImageDataUrl, imgFmt, drawX, drawY, drawW, drawH);



    } catch { /* skip */ }







    y += IMG_H + 2;



  }







  /* ═══════════════════════════════════════════════════════════════



     5.  TEST / SPECIFICATION / RESULT TABLE



         Compact padding: header top/bottom 2, body top/bottom 1.5



         Row ≈ 5 mm × 5 tests ≈ 25 mm + 6 mm header = 31 mm



  ═══════════════════════════════════════════════════════════════ */



  const tests = Array.isArray(coa.tests) ? coa.tests.filter(t => t.test_name) : [];







  autoTable(doc, {



    startY: y,



    head: [[



      { content: 'Test', styles: { halign: 'left' } },



      { content: 'Specification', styles: { halign: 'left' } },



      { content: 'Result', styles: { halign: 'center' } },



    ]],



    body: tests.length > 0



      ? tests.map(t => [



        sanPdf(t.test_name),



        sanPdf(t.specification),



        { content: sanPdf(t.result), styles: { halign: 'center', fontStyle: 'bold' } },



      ])



      : [[{ content: '(No test data entered)', colSpan: 3, styles: { halign: 'center', textColor: SUB_TEXT, fontStyle: 'italic' } }]],



    theme: 'grid',



    margin: { left: ML - 2, right: MR - 2 },



    headStyles: {



      fillColor: HDR_BG, textColor: [255, 255, 255], fontStyle: 'bold',



      fontSize: 7.5, cellPadding: { top: 2, bottom: 2, left: 3, right: 3 },



    },



    styles: {



      fontSize: 7.5, cellPadding: { top: 1.5, bottom: 1.5, left: 3, right: 3 },



      textColor: VAL_TEXT, lineColor: BORDER_C, lineWidth: 0.2,



    },



    alternateRowStyles: { fillColor: [248, 250, 255] },



    columnStyles: {



      0: { cellWidth: 52 },



      1: { cellWidth: 94 },



      2: { cellWidth: CW - 146 },



    },



    didAddPage: () => { drawPageBorder(); drawBottomStrip(); },



  });



  y = doc.lastAutoTable.finalY;







  /* ═══════════════════════════════════════════════════════════════



     6.  ATTACHMENTS ROW



  ═══════════════════════════════════════════════════════════════ */



  if (coa.attachments) {



    autoTable(doc, {



      startY: y,



      body: [[lbStyle('Attachments'), { content: coa.attachments, colSpan: 3, styles: { fillColor: [255, 255, 255], textColor: VAL_TEXT, fontSize: 7.2, fontStyle: 'normal', cellPadding: { top: 1.5, bottom: 1.5, left: 3, right: 2 }, lineColor: BORDER_C, lineWidth: 0.2 } }]],



      theme: 'plain',



      tableLineColor: BORDER_C, tableLineWidth: 0.2,



      margin: { left: ML - 2, right: MR - 2 },



      columnStyles: { 0: { cellWidth: LW }, 1: { cellWidth: VW }, 2: { cellWidth: LW }, 3: { cellWidth: VW } },



      didAddPage: () => { drawPageBorder(); drawBottomStrip(); },



    });



    y = doc.lastAutoTable.finalY;



  }







  /* ═══════════════════════════════════════════════════════════════



     PAGE BREAK GUARD — bottom sections need ~62 mm.



     If insufficient space on current page, start a new page.



  ═══════════════════════════════════════════════════════════════ */



  const BOTTOM_RESERVE = 62;   // sig(20) + gap(4) + disc(13) + tagline(8) + footer(17)



  const safeBottom = H - 8 - 2;  // above navy strip + small margin







  if (y + BOTTOM_RESERVE > safeBottom) {



    doc.addPage();



    drawPageBorder();



    drawBottomStrip();



    y = 12;



  } else {



    y += 5;



  }







  /* ═══════════════════════════════════════════════════════════════



     7.  SIGNATURE BLOCKS — height 20 mm



  ═══════════════════════════════════════════════════════════════ */



  const sigBoxW = (CW - 16) / 2;



  const sig1X = ML;



  const sig2X = ML + sigBoxW + 16;







  [[sig1X, coa.reviewer1_name || ''], [sig2X, coa.reviewer2_name || '']].forEach(([sx, name]) => {



    doc.setDrawColor(...BORDER_C); doc.setLineWidth(0.25);



    doc.roundedRect(sx, y, sigBoxW, 20, 2, 2);







    doc.setFont('helvetica', 'normal'); doc.setFontSize(7); doc.setTextColor(...SUB_TEXT);



    doc.text(today, sx + sigBoxW / 2, y + 4.5, { align: 'center' });







    doc.setFont('helvetica', 'bold'); doc.setFontSize(7); doc.setTextColor(...NAVY_COA);



    doc.text('Reviewed & Approved by', sx + sigBoxW / 2, y + 9.5, { align: 'center' });







    doc.setDrawColor(...DARK); doc.setLineWidth(0.35);



    doc.line(sx + 8, y + 15, sx + sigBoxW - 8, y + 15);







    doc.setFont('helvetica', 'normal'); doc.setFontSize(7); doc.setTextColor(...VAL_TEXT);



    doc.text(`( ${name} )`, sx + sigBoxW / 2, y + 19, { align: 'center' });



  });







  y += 24;   // 20 mm box + 4 mm gap







  /* ═══════════════════════════════════════════════════════════════



     8.  DISCLAIMER



  ═══════════════════════════════════════════════════════════════ */



  doc.setDrawColor(...BORDER_C); doc.setLineWidth(0.25);



  doc.line(ML - 2, y, W - MR + 2, y);



  y += 3;







  doc.setFont('helvetica', 'bolditalic'); doc.setFontSize(6.2); doc.setTextColor(...SUB_TEXT);



  doc.text('All dates are mentioned in the format of DD-MM-YYYY', W / 2, y, { align: 'center' });



  y += 3.5;



  doc.setFont('helvetica', 'normal'); doc.setFontSize(5.8); doc.setTextColor(...SUB_TEXT);



  const disc =



    'The re-test data is assigned based on the literature available. The balances used are calibrated with weights traceable to the National standards NIST.';



  const discLines = doc.splitTextToSize(disc, CW);



  discLines.forEach(line => { doc.text(line, W / 2, y, { align: 'center' }); y += 3.2; });



  y += 0.5;



  doc.setFont('helvetica', 'bold'); doc.setFontSize(5.8);



  doc.text(



    'info@prasilabs.com  |  www.prasilabs.com  |  Worldwide Helpline: +91(916) 000-6515  |  CIN: U24290TG2021PTC148865',



    W / 2, y, { align: 'center' }



  );



  y += 4;







  /* ═══════════════════════════════════════════════════════════════



     9.  GOLD TAGLINE BAR — 6 mm



  ═══════════════════════════════════════════════════════════════ */



  doc.setFillColor(...GOLD_BAR);



  doc.rect(ML - 2, y, CW + 4, 6, 'F');



  doc.setFont('helvetica', 'bolditalic'); doc.setFontSize(7); doc.setTextColor(60, 30, 0);



  doc.text(



    '"We are perfect for solving problems because we have all the SOLUTIONS"',



    W / 2, y + 4.2, { align: 'center' }



  );



  y += 8;







  /* ═══════════════════════════════════════════════════════════════



     10.  CORPORATE FOOTER — address left, QR right



  ═══════════════════════════════════════════════════════════════ */



  const footerTopY = y;



  doc.setFont('helvetica', 'bold'); doc.setFontSize(6.5); doc.setTextColor(...NAVY_COA);



  doc.text('Corporate Office', ML, y);



  y += 3.5;



  const addrLines = [



    'PRASI LABS PVT LIMITED',



    'Plot No 23 & 24, Shakthipuram, TSIIC Extn, Prashanti Nagar, IDA Kukatpally,',



    'Hyderabad, Telangana - 500072, Bharat (India)',



    'M: +91 9160006515   E: info@prasilabs.com',



  ];



  doc.setFont('helvetica', 'normal'); doc.setFontSize(6); doc.setTextColor(...SUB_TEXT);



  addrLines.forEach(line => { doc.text(line, ML, y); y += 3.2; });







  // QR code (right of footer)



  const qrSz = 20;



  const qrX = W - MR - qrSz;



  if (coaQrDataUrl) {



    try { doc.addImage(coaQrDataUrl, 'PNG', qrX, footerTopY, qrSz, qrSz); } catch { /* skip */ }



  }



  doc.setFont('helvetica', 'normal'); doc.setFontSize(5); doc.setTextColor(...SUB_TEXT);



  doc.text(coa.coa_number || '', qrX + qrSz / 2, footerTopY + qrSz + 2, { align: 'center' });



  doc.text('Scan for details', qrX + qrSz / 2, footerTopY + qrSz + 5, { align: 'center' });



  doc.save(`${(coa.coa_number || 'coa').replace(/[^a-zA-Z0-9-]/g, '_')}_coa.pdf`);



}

